import useCashReceipt from "../../components/KioskReceipt/useCashReceipt";
import KioskReceipt from "../../components/KioskReceipt";
import KioskCheckout from "../../components/TerminalCheckout/KioskCheckout";
import { getOldDraftCutoff, matchesRetailDraft } from "../../shared/utils/retailDraftFilters";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import {
    AssignmentReturn,
    Add,
    Archive,
    DeleteOutline,
    LocalShipping,
    Logout,
    MoneyOffCsred,
    ShoppingCartCheckout,
    Stars,
} from "@mui/icons-material";
import {
    Alert,
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogTitle,
    FormControlLabel,
    InputAdornment,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Switch,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    Typography,
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AppContext } from "../../AppContext";
import { isRoleAdmin, isRoleService } from "../../frappeConfig";
import ClosedOrders from "../../components/ClosedOrders/ClosedOrders";
import CompanyPicker from "../../components/CompanyPicker/CompanyPicker";
import HelmetMeta from "../../components/HelmetMeta";
import LanguageToggle from "../../components/LanguageToggle/LanguageToggle";
import LogoutButton from "../../components/LogoutButton";
import LoyaltyProgramDrawer from "../../components/LoyaltyProgram/LoyaltyProgramDrawer";
import PosCashCloseDialog from "../../components/PosCashCloseDialog/PosCashCloseDialog";
import PosProfilePicker from "../../components/PosProfilePicker";
import { showReservationPrompt } from "../../components/ReservationPromptDialog";
import GroupList from "../../sections/restaurant/items/GroupList";
import SubGroupList from "../../sections/restaurant/items/SubGroupList";
import { PosContext } from "../../shared/PosContext";
import {
    getOrderDoctype,
    isDraftTableOrder,
} from "../../shared/draftOrderUtils";
import {
    createEmptyRetailScanBurst,
    isLikelyRetailScannerBurst,
    isRetailScanTerminator,
    RETAIL_SCAN_IDLE_MS,
    updateRetailScanBurst,
} from "../../shared/utils/retailSearchUtils";
import {
    useDeleteDoctype,
    useSiteSettings,
} from "../../shared/hooks/useFrappeDoctype";
import { fetchRetailItemsForSearch } from "../../shared/hooks/useItemsData";
import { useCanUseInterCompanyStockTransfer } from "../../shared/hooks/useUser";
import {
    useDeleteOrder,
    usePushItemToOrderData,
    useRemoveItemFromTableOrderData,
} from "../../shared/hooks/useTableOrderItemsData";
import {
    useAddNewOrder,
    useAddNewOrderDraft,
    usePushOrderItems,
    usePushOrderItemsDraft,
    useSendTableOrder,
    useTableOrdersLazy
} from "../../shared/hooks/useTableOrdersData";
import {
    cloneAddOn,
    defaultErrorToast,
    getOrderShortName,
    getTakeawayUrlSegment,
    isJsonString,
    isTakeawayRouteTableName,
    randomId,
} from "../../utils/floorUtils";
import config from "../../config";
import cayLogo from "../../images/logo.png";
import AddItemWidget from "../Selling/Widgets/AddItemWidget";
import { hydrateAddonTreeForCart } from "../Selling/Widgets/AddItemWidget/addonTree";
import WidgetsDialogs from "../Widgets/WidgetsDialogs";
import CashOutDialog from "./components/CashOutDialog/CashOutDialog";
import InterCompanyStockTransferDialog from "./components/InterCompanyStockTransferDialog";
import OrderCart from "./components/OrderCart";
import PosItemList from "./components/PosItemList";
import RetailReturnDialog from "./components/RetailReturnDialog";
import { isAddonChildCartEntry } from "./components/retailReturnUtils";
import SplitItemDialog from "./components/SplitItemDialog";
import { v4 as uuidv4 } from "uuid";
import { useStyles } from "./styles";

const fetchReservedDesignatedNumbers = async () => {
    try {
        const filters = [["status", "=", "Draft"]];
        const params = {
            doctype: "Draft Table Order",
            fields: JSON.stringify(["designated_number"]),
            filters: JSON.stringify(filters),
            order_by: "modified desc",
            limit_start: 0,
            limit_page_length: 500,
        };

        const { data } = await axios.get("method/frappe.client.get_list", {
            params,
        });

        const rows = data?.message || [];
        return rows
            .map((r) => r?.designated_number)
            .filter((v) => v !== null && v !== undefined && String(v).trim() !== "")
            .map((v) => parseInt(v, 10))
            .filter((n) => Number.isFinite(n) && n >= 1 && n <= 200);
    } catch (e) {
        // Fail open: if we can't fetch, still allow selecting any number.
        console.warn("Failed to fetch reserved designated numbers", e);
        return [];
    }
};

const retryRetailScanRequest = async (request, attempts = 2) => {
    let lastError;
    for (let attempt = 0; attempt < attempts; attempt += 1) {
        try {
            return await request();
        } catch (error) {
            lastError = error;
        }
    }
    throw lastError;
};

const PosPage = ({ kioskMode = false }) => {
    const { t } = useTranslation();
    const {
        changeSelectedTable,
        selectedTable,
        setSelectedTable,
        isAppLoading,
        selectedOrder,
        setSelectedOrder,
        setOrders,
        orderItems,
        getMenuItem,
        customers,
        customerContext,
        addressContext,
        menuItems,
        setTakeawayOrder,
        addonsItems,
        groupedItems,
        refetchTablesData,
        refetchMenuItems,
        retailItemSearchTerm,
        setRetailItemSearchTerm,
        isMenuItemsFetching,
        refetchCustomers,
        refetchAddresses,
        takeawayTable,
        tables,
    } = useContext(PosContext);

    const {
        isTabsPos,
        userMenuSettings,
        updateUserMenuSettings,
        passwordRestrictions,
        restaurantSettings,
        menuAllowedGroups,
        menuRootGroupId,
        isCallCenterUser,
        isRetailPos,
        hideClosedOrders,
        posProfile,
        userInfo,
        company,
        companies,
        isKioskUser,
    } = useContext(AppContext);
    const isKioskMode = kioskMode || isKioskUser;

    useEffect(() => {
        if (!isKioskMode) return;

        // Include dialogs rendered through portals without blocking touch scrolling.
        const preventContextMenu = (event) => event.preventDefault();
        document.addEventListener("contextmenu", preventContextMenu, true);
        return () => document.removeEventListener("contextmenu", preventContextMenu, true);
    }, [isKioskMode]);

    const { data: hasInterCompanyStockTransferRole = false } =
        useCanUseInterCompanyStockTransfer(
            userInfo?.name,
            isRetailPos && (companies?.length || 0) > 1
        );
    const canUseInterCompanyStockTransfer =
        isRetailPos &&
        (companies?.length || 0) > 1 &&
        hasInterCompanyStockTransferRole;

    const cartItemLookup = useMemo(() => {
        const lookup = new Map();
        [...(menuItems || []), ...(addonsItems || [])].forEach((candidate) => {
            const code = candidate?.item_code || candidate?.name;
            if (code) lookup.set(code, candidate);
        });
        return lookup;
    }, [menuItems, addonsItems]);

    const rootGroupId = menuRootGroupId || "All Item Groups";
    const isServiceUser = isRoleService(userInfo?.role_profile_name);
    const isRetailServiceUser = isRetailPos && isServiceUser;
    const isAdminRole =
        isRoleAdmin(userInfo?.role_profile_name) ||
        isRoleAdmin(userInfo?.full_name) ||
        isRoleAdmin(userInfo?.name);

    const navigate = useNavigate();

    const { tableName, orderName } = useParams();
    const [searchParams] = useSearchParams();
    const isFromCancelDuplicate =
        searchParams.get("from_cancel_duplicate") === "1";

    const { mutateAsync: deleteDoc } = useDeleteDoctype();

    const isRouteTakeaway = useMemo(
        () =>
            isTakeawayRouteTableName(tableName, posProfile, takeawayTable),
        [tableName, posProfile, takeawayTable]
    );
    const isTakeaway = isRetailPos || isRouteTakeaway;

    const takeawayPathSegment = useMemo(
        () => getTakeawayUrlSegment(posProfile, takeawayTable),
        [posProfile, takeawayTable]
    );
    const retailFallbackTableName = useMemo(
        () =>
            posProfile?.takeaway_table ||
            takeawayTable?.name ||
            takeawayTable?.tableDescription ||
            "takeaway",
        [posProfile?.takeaway_table, takeawayTable]
    );

    const [tmpOrderItems, setTmpOrderItems] = useState([]);

    const [selectedCustomer, setSelectedCustomer] = customerContext;
    const [selectedAddress, setSelectedAddress] = addressContext;
    const defaultTakeawayCustomer = posProfile?.customer || "takeaway-customer";

    // Optional preselect (used from OrderTabs -> "Create new order for customer")
    const preselectCustomer = searchParams.get("customer");
    const preselectAddress = searchParams.get("address");

    const classes = useStyles();

    const [toCloseTable, setToCloseTable] = useState(null);

    // const [selectedOrder, setSelectedOrder] = useState(null);

    const [category, setCategory] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [subCategory, setSubCategory] = useState(null);
    const [currentSubGroups, setCurrentSubGroups] = useState([]);

    const [addItemOpen, setAddItemOpen] = useState(false);
    const [addedItem, setAddedItem] = useState(null);

    const [editOrderItemOpen, setEditOrderItemOpen] = useState(false);
    const [editedItem, setEditedItem] = useState(null);
    const [editedOrderItem, setEditedOrderItem] = useState(null);
    const [menuItems1, setMenuItems1] = useState(null);

    const pushItemToOrderMutation = usePushItemToOrderData(); //room, tableFormData
    const removeOrderItemMutation = useRemoveItemFromTableOrderData();
    const deleteOrderMutation = useDeleteOrder();

    const [items, setItems] = useState([]);
    const [savedItems, setSavedItems] = useState([]);
    const [hasDraftPendingChanges, setHasDraftPendingChanges] = useState(false);

    const { data: toCloseTableOrders, refetch: fetchCloseTableOrders } =
        useTableOrdersLazy(toCloseTable?.name || null);

    const [widgetDialogTable, setWidgetDialogTable] = useState(null);
    const [widgetsDialogsOpen, setWidgetsDialogsOpen] = useState(false);
    const retailOrderRequestRef = useRef(0);
    const retailSearchInputRef = useRef(null);
    const retailSearchInputValueRef = useRef("");
    const retailInputBurstRef = useRef(createEmptyRetailScanBurst());
    const retailInputIdleTimerRef = useRef(null);
    const retailGlobalBurstRef = useRef(createEmptyRetailScanBurst());
    const retailGlobalIdleTimerRef = useRef(null);
    const retailScanQueueRef = useRef([]);
    const retailScanProcessingRef = useRef(false);
    const processRetailScanRef = useRef(null);
    const enqueueRetailScanRef = useRef(null);
    const [pendingAutoCloseOrderName, setPendingAutoCloseOrderName] =
        useState(null);
    const [retailDraftToDelete, setRetailDraftToDelete] = useState(null);
    const [retailDraftSalesOpen, setRetailDraftSalesOpen] = useState(false);
    const [retailStockError, setRetailStockError] = useState("");
    const [retailDraftSearch, setRetailDraftSearch] = useState("");
    const [retailDraftOldOnly, setRetailDraftOldOnly] = useState(false);
    const [retailDraftCutoff, setRetailDraftCutoff] = useState(null);
    const [retailDraftSalesError, setRetailDraftSalesError] = useState(false);
    const [retailDraftSales, setRetailDraftSales] = useState([]);
    const [retailDraftSalesLoading, setRetailDraftSalesLoading] =
        useState(false);
    const [pendingRetailDraftSale, setPendingRetailDraftSale] = useState(null);
    const [retailDraftReplaceConfirmOpen, setRetailDraftReplaceConfirmOpen] =
        useState(false);
    const [retailNewSaleConfirmOpen, setRetailNewSaleConfirmOpen] =
        useState(false);
    const [retailClosedOrdersOpen, setRetailClosedOrdersOpen] = useState(false);
    const [retailReturnOpen, setRetailReturnOpen] = useState(false);
    const [retailCloseCashOpen, setRetailCloseCashOpen] = useState(false);
    const [retailCashOutOpen, setRetailCashOutOpen] = useState(false);
    const [retailLoyaltyOpen, setRetailLoyaltyOpen] = useState(false);
    const [retailStockTransferOpen, setRetailStockTransferOpen] =
        useState(false);

    const [isDragDropMode, setIsDragDropMode] = useState(false);
    const [isQuickAddMode, setIsQuickAddMode] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [itemViewMode, setItemViewMode] = useState(
        userMenuSettings?.retail_item_view_mode === "list" ? "list" : "grid"
    );
    const [barcodeItemCode, setBarcodeItemCode] = useState(null);
    const { data: siteSettings } = useSiteSettings();
    const normalizedSearchText = String(searchText || "").trim();
    const showRetailCatalog =
        !isRetailPos ||
        Boolean(normalizedSearchText) ||
        Boolean(barcodeItemCode);
    const isRetailItemSearchPending =
        isRetailPos &&
        Boolean(normalizedSearchText) &&
        normalizedSearchText !== retailItemSearchTerm;

    useEffect(() => {
        if (!isRetailPos) return undefined;

        const normalizedSearchTerm = normalizedSearchText;
        if (!normalizedSearchTerm) {
            setRetailItemSearchTerm("");
            return undefined;
        }

        const timeoutId = window.setTimeout(() => {
            setRetailItemSearchTerm(normalizedSearchTerm);
        }, 300);

        return () => window.clearTimeout(timeoutId);
    }, [isRetailPos, normalizedSearchText, setRetailItemSearchTerm]);
    const retailLogoUrl = useMemo(() => {
        const logo = siteSettings?.docs?.[0]?.logo;
        return logo ? `${config.baseUrl}${logo}` : cayLogo;
    }, [siteSettings]);

    useEffect(() => {
        const savedRetailViewMode = userMenuSettings?.retail_item_view_mode;
        if (
            isRetailPos &&
            (savedRetailViewMode === "grid" || savedRetailViewMode === "list") &&
            savedRetailViewMode !== itemViewMode
        ) {
            setItemViewMode(savedRetailViewMode);
        }
    }, [isRetailPos, itemViewMode, userMenuSettings?.retail_item_view_mode]);

    const handleItemViewModeChange = (nextMode) => {
        if (!nextMode || nextMode === itemViewMode) return;
        setItemViewMode(nextMode);
        if (isRetailPos) {
            updateUserMenuSettings({
                retail_item_view_mode: nextMode,
            });
        }
    };

    useEffect(() => {
        if (!isTakeaway) return;

        const orderCustomer = String(selectedOrder?.customer || "").trim();
        const orderAddress = String(selectedOrder?.address || "").trim();

        if (orderCustomer) {
            setSelectedCustomer(orderCustomer);
            setSelectedAddress(orderAddress || null);
            return;
        }

        if (!orderName && preselectCustomer) {
            setSelectedCustomer(preselectCustomer);
            setSelectedAddress(preselectAddress || null);
            return;
        }

        setSelectedCustomer(defaultTakeawayCustomer);
        setSelectedAddress(null);
    }, [
        isTakeaway,
        orderName,
        selectedOrder?.name,
        selectedOrder?.customer,
        selectedOrder?.address,
        preselectCustomer,
        preselectAddress,
        defaultTakeawayCustomer,
        setSelectedCustomer,
        setSelectedAddress,
    ]);

    useEffect(() => {
        if (!isAppLoading) {
            if (isRetailPos) {
                if (takeawayTable) {
                    setSelectedTable(takeawayTable);
                    if (orderName) {
                        setTakeawayOrder(orderName);
                    }
                } else {
                    changeSelectedTable(retailFallbackTableName, orderName);
                }
            } else if (isTakeaway) {
                setTakeawayOrder(orderName);
            } else {
                changeSelectedTable(tableName, orderName);
            }
        }
        // Re-run when floor/takeaway payload arrives: first run often has no
        // takeawayTable/tables yet, which left selectedTable unset and hid OrderCart.
    }, [
        isAppLoading,
        tableName,
        orderName,
        isRetailPos,
        isTakeaway,
        takeawayTable,
        tables,
        retailFallbackTableName,
        setTakeawayOrder,
        setSelectedTable,
        changeSelectedTable,
    ]);

    useEffect(() => {
        if (tmpOrderItems.length > 0) {
            setItems(tmpOrderItems);
        } else {
            setItems([]);
        }
    }, [tmpOrderItems]);

    useEffect(() => {
        if (toCloseTable) fetchCloseTableOrders();
    }, [toCloseTable]);

    useEffect(() => {
        //-TODO NEW CHANGES
        if (isServiceUser) {
            setWidgetDialogTable(null);
            setWidgetsDialogsOpen(false);
        } else if (toCloseTableOrders && toCloseTableOrders.length > 0) {
            setWidgetDialogTable(toCloseTable);
            setWidgetsDialogsOpen(true);
        } else {
            setWidgetDialogTable(null);
            setWidgetsDialogsOpen(false);
        }
    }, [toCloseTableOrders, isServiceUser]);

    const updateOrderItems = (_orderItems) => {
        const _items = _orderItems || orderItems;
        const cartItems = [];
        _items
            .filter((i) => !i.parent_item || i.parent_item == "NULL")
            .forEach((i) => {
                const menuItem =
                    getMenuItem(i.item_code) || (isRetailPos ? i : null);
                if (menuItem) {
                    const addonsArray = Array.isArray(i.addons)
                        ? i.addons
                        : i.addons
                          ? JSON.parse(i.addons)
                          : [];
                    const itemAddons = hydrateAddonTreeForCart(
                        addonsArray,
                        cartItemLookup
                    );
                    cartItems.push({
                        item: {
                            ...i,
                            cover: menuItem.cover || i.cover,
                            standard_rate:
                                menuItem.standard_rate ?? i.standard_rate,
                            // Needed for UI-only logic (e.g., hiding default bundle options)
                            menu_item_bundle: menuItem.menu_item_bundle,
                        },
                        addons: itemAddons,
                        qty: i.qty,
                        // The persisted row identifier is unique per order line;
                        // a menu-item identifier can be shared by duplicate rows.
                        entry_name:
                            i.identifier || menuItem.identifier || i.item_code,
                    });
                }
            });

        setSavedItems(cartItems);
    };

    useEffect(() => {
        // This effect owns only persisted rows. `items` mirrors
        // `tmpOrderItems` above, so changing it here can erase a newly scanned
        // cart line when persisted order data refreshes.
        if (!orderItems || orderItems.length === 0) {
            setSavedItems([]);
            return;
        }

        if (addonsItems) {
            updateOrderItems();
        }
    }, [orderItems, addonsItems, cartItemLookup]);

    useEffect(() => {
        if (isTakeaway) {
            if (!orderName) {
                setSavedItems([]);
            }
            setTmpOrderItems([]);
            setItems([]);
            setHasDraftPendingChanges(false);
        }
    }, [isTakeaway, orderName]);

    useEffect(() => {
        if (editedOrderItem) {
            let itemInOrder;
            if (menuItems1 && menuItems1.length > 0)
                itemInOrder = _.find(menuItems1, {
                    item_code: editedOrderItem.item_code,
                });

            if (itemInOrder) {
                setEditedItem(itemInOrder);
            }
        }
    }, [editedOrderItem]);

    // Load quick add mode from user settings
    useEffect(() => {
        if (userMenuSettings && userMenuSettings.quick_add_mode !== undefined) {
            setIsQuickAddMode(userMenuSettings.quick_add_mode);
        }
    }, [userMenuSettings]);

    // Save quick add mode when it changes
    const handleQuickAddModeChange = (newMode) => {
        setIsQuickAddMode(newMode);
        updateUserMenuSettings({ quick_add_mode: newMode });
    };

    /**
     * Quick add item to cart without opening dialog
     * @param item
     */
    const quickAddItem = (item) => {
        const targetUom = String(item.uom || item.stock_uom || "").trim();
        setTmpOrderItems((currentItems) => {
            const existingItemIndex = currentItems.findIndex(
                (orderItem) => {
                    const orderItemUom = String(
                        orderItem.item.uom || orderItem.item.stock_uom || ""
                    ).trim();
                    return (
                        orderItem.item.item_code === item.item_code &&
                        orderItemUom === targetUom &&
                        (!orderItem.notes || orderItem.notes === "") &&
                        (!orderItem.addons || orderItem.addons.length === 0)
                    );
                }
            );

            if (existingItemIndex !== -1) {
                const updatedItems = [...currentItems];
                const currentItem = updatedItems[existingItemIndex];
                const nextQty = Number(currentItem.qty || 0) + 1;
                updatedItems[existingItemIndex] = {
                    ...currentItem,
                    item: {
                        ...currentItem.item,
                        qty: nextQty,
                    },
                    qty: nextQty,
                };
                return updatedItems;
            }

            return [
                ...currentItems,
                {
                    item: {
                        ...item,
                        qty: 1,
                        notes: "",
                    },
                    qty: 1,
                    addons: [],
                    notes: "",
                    entry_name: randomId(5),
                },
            ];
        });
    };

    const handleRetailReplacementQtyChange = (replacementItem, delta) => {
        if (!isRetailPos || !replacementItem || !delta) return;

        const itemCode = String(replacementItem.item_code || "").trim();
        const uom = String(replacementItem.uom || "").trim();
        if (!itemCode) return;

        setTmpOrderItems((currentItems) => {
            const matchingIndex = currentItems.findIndex((entry) => {
                const entryItem = entry?.item || entry || {};
                const entryUom = String(
                    entryItem.uom || entryItem.stock_uom || entry?.uom || ""
                ).trim();
                return (
                    !isAddonChildCartEntry(entry) &&
                    entryItem.item_code === itemCode &&
                    entryUom === uom
                );
            });
            if (matchingIndex === -1) return currentItems;

            const matchingEntry = currentItems[matchingIndex];
            const nextQty = Number(matchingEntry.qty || 0) + Number(delta);
            if (nextQty <= 0) {
                return currentItems.filter(
                    (_, index) => index !== matchingIndex
                );
            }

            const updatedItems = [...currentItems];
            updatedItems[matchingIndex] = {
                ...matchingEntry,
                item: {
                    ...matchingEntry.item,
                    qty: nextQty,
                },
                qty: nextQty,
            };
            return updatedItems;
        });
    };

    processRetailScanRef.current = async (searchValue) => {
        try {
            const { data } = await retryRetailScanRequest(() =>
                axios.post(
                    "method/erpnext.selling.page.point_of_sale.point_of_sale.search_for_serial_or_batch_or_barcode_number",
                    { search_value: searchValue }
                )
            );
            const barcodeMatch = data?.message;
            const matchedItemCode = barcodeMatch?.item_code;

            if (!matchedItemCode) {
                if (
                    retailScanQueueRef.current.length === 0 &&
                    !retailSearchInputValueRef.current
                ) {
                    retailSearchInputValueRef.current = searchValue;
                    setSearchText(searchValue);
                    setRetailItemSearchTerm(searchValue);
                }
                return;
            }

            const matchedItems = await retryRetailScanRequest(() =>
                fetchRetailItemsForSearch({
                    allowedGroups: menuAllowedGroups,
                    posProfile,
                    searchTerm: searchValue,
                })
            );
            const matchedItem = matchedItems.find(
                (item) => item.item_code === matchedItemCode
            );

            if (!matchedItem) {
                if (
                    retailScanQueueRef.current.length === 0 &&
                    !retailSearchInputValueRef.current
                ) {
                    retailSearchInputValueRef.current = searchValue;
                    setSearchText(searchValue);
                    setBarcodeItemCode(matchedItemCode);
                    setRetailItemSearchTerm(searchValue);
                }
                enqueueSnackbar(t("retailPos.scannedItemUnavailable"), {
                    variant: "warning",
                });
                return;
            }

            quickAddItem({
                ...matchedItem,
                barcode: barcodeMatch.barcode || matchedItem.barcode,
                uom: barcodeMatch.uom || matchedItem.uom,
                serial_no: barcodeMatch.serial_no || matchedItem.serial_no,
                batch_no: barcodeMatch.batch_no || matchedItem.batch_no,
                has_serial_no:
                    barcodeMatch.serial_no ? 1 : matchedItem.has_serial_no,
                has_batch_no:
                    barcodeMatch.batch_no ? 1 : matchedItem.has_batch_no,
            });
            setBarcodeItemCode(null);
        } catch (error) {
            console.error("Failed to add scanned retail item", error);
            setBarcodeItemCode(null);
            enqueueSnackbar(t("retailPos.scanAddFailed"), {
                variant: "error",
            });
        }
    };

    const drainRetailScanQueue = () => {
        if (retailScanProcessingRef.current) return;
        retailScanProcessingRef.current = true;

        const drain = async () => {
            try {
                while (retailScanQueueRef.current.length > 0) {
                    const nextScan = retailScanQueueRef.current.shift();
                    await processRetailScanRef.current?.(nextScan);
                }
            } finally {
                retailScanProcessingRef.current = false;
                if (retailScanQueueRef.current.length > 0) {
                    drainRetailScanQueue();
                }
            }
        };

        void drain();
    };

    const enqueueRetailScan = (value) => {
        const normalizedValue = String(value || "").trim();
        if (!normalizedValue) return;

        // Clear immediately so the next fast scan starts with an empty input,
        // even while an earlier scan is still waiting on the server.
        retailSearchInputValueRef.current = "";
        setSearchText("");
        setBarcodeItemCode(null);
        setRetailItemSearchTerm("");
        retailScanQueueRef.current.push(normalizedValue);
        drainRetailScanQueue();
    };
    enqueueRetailScanRef.current = enqueueRetailScan;

    const resetRetailInputBurst = () => {
        if (retailInputIdleTimerRef.current) {
            window.clearTimeout(retailInputIdleTimerRef.current);
            retailInputIdleTimerRef.current = null;
        }
        retailInputBurstRef.current = createEmptyRetailScanBurst();
    };

    const scheduleRetailInputScan = () => {
        if (retailInputIdleTimerRef.current) {
            window.clearTimeout(retailInputIdleTimerRef.current);
        }
        retailInputIdleTimerRef.current = window.setTimeout(() => {
            retailInputIdleTimerRef.current = null;
            const burst = retailInputBurstRef.current;
            if (
                isLikelyRetailScannerBurst(burst) &&
                burst.value === retailSearchInputValueRef.current
            ) {
                retailInputBurstRef.current = createEmptyRetailScanBurst();
                enqueueRetailScanRef.current?.(burst.value);
            }
        }, RETAIL_SCAN_IDLE_MS);
    };

    const handleSearchTextChange = (event) => {
        const value = event.target.value;
        retailSearchInputValueRef.current = value;
        setBarcodeItemCode(null);
        setSearchText(value);

        if (!isRetailPos) return;
        retailInputBurstRef.current = updateRetailScanBurst(
            retailInputBurstRef.current,
            value,
            event.timeStamp
        );
        scheduleRetailInputScan();
    };

    const handleSearchKeyDown = (event) => {
        if (
            !isRetailPos ||
            event.nativeEvent?.isComposing ||
            !isRetailScanTerminator(event.key)
        ) {
            return;
        }

        const searchValue = String(event.currentTarget.value || "").trim();
        if (!searchValue) return;

        event.preventDefault();
        resetRetailInputBurst();
        enqueueRetailScan(searchValue);
    };

    useEffect(() => {
        if (!isRetailPos) return undefined;

        const resetGlobalBurst = () => {
            if (retailGlobalIdleTimerRef.current) {
                window.clearTimeout(retailGlobalIdleTimerRef.current);
                retailGlobalIdleTimerRef.current = null;
            }
            retailGlobalBurstRef.current = createEmptyRetailScanBurst();
        };

        const scheduleGlobalScan = () => {
            if (retailGlobalIdleTimerRef.current) {
                window.clearTimeout(retailGlobalIdleTimerRef.current);
            }
            retailGlobalIdleTimerRef.current = window.setTimeout(() => {
                retailGlobalIdleTimerRef.current = null;
                const burst = retailGlobalBurstRef.current;
                if (isLikelyRetailScannerBurst(burst)) {
                    retailGlobalBurstRef.current =
                        createEmptyRetailScanBurst();
                    enqueueRetailScanRef.current?.(burst.value);
                }
            }, RETAIL_SCAN_IDLE_MS);
        };

        const handleGlobalScannerKeyDown = (event) => {
            if (event.isComposing || event.repeat) return;
            if (event.target === retailSearchInputRef.current) return;
            if (document.querySelector('[role="dialog"]')) {
                resetGlobalBurst();
                return;
            }

            const tagName = String(event.target?.tagName || "").toLowerCase();
            if (
                tagName === "input" ||
                tagName === "textarea" ||
                tagName === "select" ||
                event.target?.isContentEditable
            ) {
                resetGlobalBurst();
                return;
            }

            if (isRetailScanTerminator(event.key)) {
                const burst = retailGlobalBurstRef.current;
                if (isLikelyRetailScannerBurst(burst)) {
                    event.preventDefault();
                    event.stopPropagation();
                    const scanValue = burst.value;
                    resetGlobalBurst();
                    enqueueRetailScanRef.current?.(scanValue);
                } else {
                    resetGlobalBurst();
                }
                return;
            }

            if (
                event.key.length !== 1 ||
                event.ctrlKey ||
                event.metaKey ||
                event.altKey
            ) {
                if (!["Shift", "CapsLock"].includes(event.key)) {
                    resetGlobalBurst();
                }
                return;
            }

            const observedAt = event.timeStamp;
            const previousBurst = retailGlobalBurstRef.current;
            const previousObservedAt = Number(
                previousBurst.lastObservedAt || 0
            );
            const burstExpired =
                previousObservedAt > 0 &&
                observedAt - previousObservedAt > RETAIL_SCAN_IDLE_MS;
            const activeBurst = burstExpired
                ? createEmptyRetailScanBurst()
                : previousBurst;
            retailGlobalBurstRef.current = updateRetailScanBurst(
                activeBurst,
                `${activeBurst.value}${event.key}`,
                observedAt
            );
            scheduleGlobalScan();
        };

        window.addEventListener("keydown", handleGlobalScannerKeyDown, true);
        return () => {
            window.removeEventListener(
                "keydown",
                handleGlobalScannerKeyDown,
                true
            );
            resetGlobalBurst();
            if (retailInputIdleTimerRef.current) {
                window.clearTimeout(retailInputIdleTimerRef.current);
                retailInputIdleTimerRef.current = null;
            }
            retailInputBurstRef.current = createEmptyRetailScanBurst();
        };
    }, [isRetailPos]);

    /**
     * Pushes item to selected order.
     * @param item
     */
    const onItemClick = (item) => {
        const itemBudnle = item.menu_item_bundle
            ? JSON.parse(item.menu_item_bundle)
            : null;
        const skipQuickAdd =
            itemBudnle &&
            itemBudnle.categories &&
            itemBudnle.categories.length > 0;
        if (!isKioskMode && (isRetailPos || isQuickAddMode) && !skipQuickAdd) {
            quickAddItem(item);
        } else {
            setAddedItem(item);
            setAddItemOpen(true);
        }
    };

    const handleAddItemClose = () => {
        setAddItemOpen(false);
        setEditOrderItemOpen(false);
        setEditedItem(null);
        setEditedOrderItem(null);
    };

    const handleInvoiceClosed = () => {
        if (isRetailPos) {
            const paidOrderName = selectedOrder?.name;
            retailOrderRequestRef.current += 1;
            handleCloseDialog();
            setSelectedOrder(null);
            setOrders((current) =>
                Array.isArray(current)
                    ? current.filter((order) => order?.name !== paidOrderName)
                    : current
            );
            setSavedItems([]);
            setTmpOrderItems([]);
            setItems([]);
            setHasDraftPendingChanges(false);
            refetchTablesData();
            refetchMenuItems();
            navigate("/pos", { replace: true });
            return;
        }

        if (isTakeaway) {
            // In tabs POS mode the operator works through a queue of orders, so
            // once the invoice is paid we send them straight back to /tables
            // instead of leaving them on the now-closed order screen.
            if (isTabsPos) {
                handleCloseDialog();
                refetchTablesData();
                navigateHome();
                return;
            }
            refetchTablesData().then((res) => {
                const orders = res.data.message.takeaway?.orders;

                if (orders && orders[orderName]) {
                    const newItems = (orders[orderName].entry_items || [])
                        // Skip parent-item child rows (addon entries) — they don't
                        // map to a top-level menu item and would otherwise produce
                        // undefined entries below.
                        .filter(
                            (i) => !i.parent_item || i.parent_item == "NULL"
                        )
                        .map((i) => {
                            const menuItem =
                                getMenuItem(i.item_code) ||
                                (isRetailPos ? i : null);
                            if (!menuItem) return null;
                            return {
                                item: {
                                    ...i,
                                    cover: menuItem.cover || i.cover,
                                    standard_rate:
                                        menuItem.standard_rate ??
                                        i.standard_rate,
                                },
                                addons: hydrateAddonTreeForCart(
                                    i.addons
                                        ? isJsonString(i.addons)
                                            ? JSON.parse(i.addons)
                                            : i.addons
                                        : [],
                                    cartItemLookup
                                ),
                                qty: i.qty,
                                entry_name: i.item_code,
                            };
                        })
                        .filter(Boolean);

                    setSavedItems(newItems);
                    handleCloseDialog();
                } else {
                    navigateHome();
                }
            });
        } else {
            navigateHome();
        }
    };

    const addItemToOrder = (item) => {
        setTmpOrderItems((prevState) => [...prevState, item]);
    };

    const mapAddonToOrderItemPayload = (addon) => {
        if (!addon) return null;
        if (typeof addon === "string") {
            return {
                item_code: addon,
            };
        }
        return {
            item_code: addon.item_code,
            item_name: addon.item_name,
            name: addon.name,
            identifier: addon.identifier,
            rate: addon.rate,
            standard_rate: addon.rate ?? addon.standard_rate,
            qty: addon.qty,
            bundle_category: addon.bundle_category,
            label: addon.label,
            addons: (Array.isArray(addon.addons) ? addon.addons : [])
                .map(mapAddonToOrderItemPayload)
                .filter(Boolean),
        };
    };

    const mapTmpCartItemToOrderItemPayload = (i) => ({
        identifier: i.item?.identifier || i.identifier,
        item: i.item?.item_code || i.item_code,
        qty: i.qty,
        standard_rate: i.item?.standard_rate ?? i.rate ?? 0,
        notes: i.notes || "",
        addons: (i.addons || []).map(mapAddonToOrderItemPayload).filter(Boolean),
    });

    const mapSavedCartItemToOrderItemPayload = (i) => ({
        identifier: i.item?.identifier || i.identifier,
        item: i.item?.item_code || i.item_code,
        qty: i.qty,
        standard_rate: i.item?.rate ?? i.item?.standard_rate ?? i.rate ?? 0,
        notes: i.notes || i.item?.notes || "",
        addons: (i.addons || []).map(mapAddonToOrderItemPayload).filter(Boolean),
    });

    const buildDraftOrderItemsPayload = ({ includeSavedItems = false } = {}) => {
        const newOrderItems = (tmpOrderItems || []).map(
            mapTmpCartItemToOrderItemPayload
        );
        if (!includeSavedItems) return newOrderItems;
        const persistedItems = (savedItems || []).map(
            mapSavedCartItemToOrderItemPayload
        );
        return [...persistedItems, ...newOrderItems];
    };

    const handleUpdateItem = (item, isNew) => {
        const itemToUpdate = { ...item };

        let updatedAddons = [];
        itemToUpdate.addons.forEach((addon) => {
            // addon can be a string (item_code) or an object { item_code, standard_rate }
            const addonCode =
                typeof addon === "string" ? addon : addon.item_code;
            const overrideRate =
                typeof addon === "object" && addon?.standard_rate != null
                    ? Number(addon.standard_rate)
                    : null;

            let addonItem = _.find(
                addonsItems,
                (it) => it.item_code === addonCode
            );
            if (!addonItem) {
                addonItem = {
                    item_code: addonCode,
                    standard_rate: overrideRate || 0,
                };
            }

            const addonSource =
                typeof addon === "object"
                    ? { ...addonItem, ...addon, item_code: addonCode }
                    : addonItem;
            const rootIdentifier =
                itemToUpdate?.item?.identifier || itemToUpdate.identifier;

            updatedAddons.push(
                cloneAddOn(
                    addonSource,
                    itemToUpdate.qty,
                    rootIdentifier,
                    overrideRate,
                    itemToUpdate.qty
                )
            );
        });
        itemToUpdate.addons = updatedAddons.length > 0 ? updatedAddons : [];

        let didUpdateTmpOrder = false;
        const currentOrders = [...tmpOrderItems];
        const updatedOrders = currentOrders.map((i) => {
            if (i.entry_name === item.entry_name) {
                didUpdateTmpOrder = true;
                return itemToUpdate;
            }
            return i;
        });

        if (didUpdateTmpOrder) {
            if (selectedOrder?.status === "Draft") {
                setHasDraftPendingChanges(true);
            }
            setTmpOrderItems(updatedOrders);
            return;
        }

        // Editing a persisted draft row updates savedItems directly.
        const targetIdentifier = itemToUpdate?.item?.identifier;
        setSavedItems((prevSavedItems) =>
            (prevSavedItems || []).map((savedItem) => {
                const sameIdentifier =
                    !!targetIdentifier &&
                    savedItem?.item?.identifier === targetIdentifier;
                const sameEntryName =
                    !!savedItem?.entry_name &&
                    !!itemToUpdate?.entry_name &&
                    savedItem.entry_name === itemToUpdate.entry_name;
                return sameIdentifier || sameEntryName
                    ? itemToUpdate
                    : savedItem;
            })
        );
        if (selectedOrder?.status === "Draft") {
            setHasDraftPendingChanges(true);
        }
    };
    const handleAddItem = (item, qty, addons, notes) => {
        // onItemClick(item, qty);

        let clonedItem = {};
        const rootIdentifier = "entry_" + uuidv4();
        clonedItem.item = {
            ...item,
            ["notes"]: notes,
            ["qty"]: qty,
            identifier: rootIdentifier,
        };
        clonedItem.identifier = rootIdentifier;

        if (qty) clonedItem.qty = qty;

        if (notes && notes.length > 0) {
            clonedItem.notes = notes;
        }

        let addonsToSave = [];
        if (addons) {
            addons.forEach((aItem) => {
                // aItem can be a string (item_code) or object { item_code, standard_rate }
                const addonCode =
                    typeof aItem === "string" ? aItem : aItem.item_code;
                const overrideRate =
                    typeof aItem === "object" && aItem?.standard_rate != null
                        ? Number(aItem.standard_rate)
                        : null;
                let addonItem = _.find(
                    addonsItems,
                    (it) => it.item_code === addonCode
                );
                if (!addonItem) {
                    addonItem = {
                        item_code: addonCode,
                        standard_rate: overrideRate || 0,
                    };
                }
                const addonSource =
                    typeof aItem === "object"
                        ? { ...addonItem, ...aItem, item_code: addonCode }
                        : addonItem;
                addonsToSave.push(
                    cloneAddOn(
                        addonSource,
                        clonedItem.qty,
                        rootIdentifier,
                        overrideRate,
                        clonedItem.qty
                    )
                );
            });
            clonedItem.addons = addonsToSave.length > 0 ? addonsToSave : [];

            clonedItem.entry_name = randomId(5);

            if (selectedOrder && selectedOrder.name) {
                addItemToOrder({
                    ...clonedItem,
                    ["notes"]: notes,
                    ["qty"]: qty,
                });
            } else {
                addItemToOrder({
                    ...clonedItem,
                    ["notes"]: notes,
                    ["qty"]: qty,
                });
                // addItemToOrder(clonedItem);
            }

            setAddItemOpen(false);
            setEditOrderItemOpen(false);
        }
    };

    const onGroupClicked = (group) => {
        if (group && !group.name) {
            setCategory(null);
            setSelectedCategory(null);
            setSubCategory(null);
            setCurrentSubGroups([]);
            return;
        }

        setCategory(group);

        // const { id, name, cover } = group;
        setSelectedCategory(group);
        setSubCategory(null);
        if (group?.id === rootGroupId) {
            setCurrentSubGroups([]);
        }
    };

    const onSubGroupClicked = (subGroup) => {
        if (subGroup && !subGroup.name) {
            setSubCategory(null);
            return;
        }
        // If the clicked subgroup is itself a group, drill down (treat it as the new category)
        if (subGroup && subGroup.is_group) {
            onGroupClicked(subGroup);
            return;
        }
        setSubCategory(subGroup);
    };

    const handleSelectOrder = (order) => {
        if (isRetailPos) {
            navigate("/pos", { replace: true });
            return;
        }
        navigate(`/pos/${tableName}/${order.name}`);
    };

    const handleRetailStockError = (error) => {
        if (error?.response?.data?.exc_type !== "RetailStockError") {
            defaultErrorToast(error);
            return;
        }
        try {
            const messages = JSON.parse(error.response.data._server_messages || "[]");
            const message = JSON.parse(messages[0]).message;
            const text = new DOMParser().parseFromString(message.replace(/<br\s*\/?>(\s*)/gi, "\n"), "text/html").body.textContent;
            setRetailStockError(text);
        } catch (_) {
            setRetailStockError(t("retailPos.insufficientStock"));
        }
    };

    const handleCloseTable = async (order, table) => {
        if (isCallCenterUser || isServiceUser) {
            // Call center and service flows never enter payment/invoicing.
            return;
        }
        if (isRetailPos && order?.name) {
            try {
                await axios.post("method/frappe_helper.api.call", {
                    model: "Table Order", name: order.name,
                    method: "check_retail_stock", args: "{}",
                });
            } catch (error) {
                handleRetailStockError(error);
                return;
            }
        }
        setWidgetDialogTable(table);
        setWidgetsDialogsOpen(true);
    };

    const navigateHome = (options) => {
        navigate(
            isKioskMode
                ? `/kiosk/${takeawayPathSegment}`
                : isRetailPos
                ? "/pos"
                : "/tables",
            options
        );
    };

    const getHiddenRetailTable = () =>
        selectedTable ||
        takeawayTable || {
            name: retailFallbackTableName,
            tableDescription: retailFallbackTableName,
            reserved: 0,
            orders: {},
        };

    const openRetailPaymentForOrder = (orderNameToOpen) => {
        if (!orderNameToOpen || isRetailServiceUser) return;
        const requestId = ++retailOrderRequestRef.current;
        axios
            .get("method/frappe.client.get", {
                params: {
                    doctype: "Table Order",
                    name: orderNameToOpen,
                },
            })
            .then(({ data }) => {
                if (retailOrderRequestRef.current !== requestId) return;
                if (!data?.message) return;
                setSelectedOrder(data.message);
                setOrders((current) => {
                    const list = Array.isArray(current) ? current : [];
                    const withoutCurrent = list.filter(
                        (order) => order?.name !== data.message.name
                    );
                    return [data.message, ...withoutCurrent];
                });
                updateOrderItems(data.message.entry_items);
                setTmpOrderItems([]);
                setItems([]);
                handleCloseTable(data.message, getHiddenRetailTable());
            })
            .catch((error) => {
                if (retailOrderRequestRef.current === requestId) {
                    defaultErrorToast(error);
                }
            });
    };

    const resetRetailSale = () => {
        if (!isRetailPos) return;
        retailOrderRequestRef.current += 1;
        setRetailNewSaleConfirmOpen(false);
        setSelectedOrder(null);
        setSavedItems([]);
        setTmpOrderItems([]);
        setItems([]);
        setHasDraftPendingChanges(false);
        setRetailDraftSalesLoading(false);
        navigate("/pos", { replace: true });
    };

    const handleRetailReturnCompleted = (result) => {
        refetchMenuItems();
        if (!result?.replacement_invoice && !result?.return_invoice && !result?.name)
            return;

        retailOrderRequestRef.current += 1;
        setSelectedOrder(null);
        setSavedItems([]);
        setTmpOrderItems([]);
        setItems([]);
        setHasDraftPendingChanges(false);
        navigate("/pos", { replace: true });
    };

    const handleRetailOrderSent = (
        orderNameToOpen,
        { startNewRetailSaleAfterSave = false } = {}
    ) => {
        if (startNewRetailSaleAfterSave || isRetailServiceUser) {
            if (isRetailServiceUser) {
                enqueueSnackbar(t("pos.sentToKitchen"), {
                    variant: "success",
                });
            }
            resetRetailSale();
            return;
        }

        openRetailPaymentForOrder(orderNameToOpen);
    };

    const hasRetailCartItems =
        (items?.length || 0) > 0 || (savedItems?.length || 0) > 0;
    const hasRetailDirtyCart =
        (items?.length || 0) > 0 || hasDraftPendingChanges;

    const handleNewRetailSaleRequest = () => {
        if (hasRetailDirtyCart) {
            setRetailNewSaleConfirmOpen(true);
            return;
        }
        resetRetailSale();
    };

    const getRetailSaleSummary = (sale) => {
        const saleItems = (sale?.entry_items || []).filter(
            (item) => !item.parent_item || item.parent_item === "NULL"
        );
        const totalQty = saleItems.reduce(
            (sum, item) => sum + (Number(item.qty) || 0),
            0
        );
        const calculatedAmount = saleItems.reduce(
            (sum, item) =>
                sum +
                (Number(item.qty) || 0) *
                    (Number(item.rate ?? item.standard_rate) || 0),
            0
        );
        const totalAmount = Number(sale?.amount ?? calculatedAmount) || 0;
        const itemSummary = saleItems
            .slice(0, 3)
            .map((item) => `${item.item_name || item.item_code} x${item.qty}`)
            .join(", ");
        const remainingCount = Math.max(saleItems.length - 3, 0);

        return {
            totalQty,
            totalAmount,
            itemSummary:
                remainingCount > 0
                    ? `${itemSummary}, +${remainingCount}`
                    : itemSummary,
        };
    };

    const filteredRetailDraftSales = retailDraftSales.filter((draft) =>
        matchesRetailDraft(draft, {
            search: retailDraftSearch,
            customerName: customers?.find((customer) => customer.name === draft.customer)?.customer_name,
            oldOnly: retailDraftOldOnly,
            cutoff: retailDraftCutoff,
        })
    );

    const fetchRetailDraftSales = () => {
        if (!isRetailPos || !selectedTable?.name) return Promise.resolve([]);
        setRetailDraftSalesLoading(true);
        setRetailDraftSalesError(false);
        const params = {
            doctype: "Table Order",
            fields: JSON.stringify(["name", "customer", "tracking_number", "creation", "modified", "table"]),
            filters: JSON.stringify([
                ["status", "=", "Attending"],
                ["table", "=", selectedTable.name],
                ["docstatus", "!=", 2],
            ]),
            order_by: "modified desc",
            limit_start: 0,
            limit_page_length: 0,
        };
        return Promise.all([
            axios.get("method/frappe.client.get_list", { params }),
            axios.get("method/frappe.client.get_time_zone"),
        ])
            .then(async ([{ data }, clock]) => {
                // Frappe creation timestamps are site-local, not browser-local.
                const cutoff = getOldDraftCutoff(clock.headers.date, clock.data?.message?.time_zone);
                const rows = data?.message || [];
                const drafts = await Promise.all(
                    rows.map((row) =>
                        axios
                            .get("method/frappe.client.get", {
                                params: {
                                    doctype: "Table Order",
                                    name: row.name,
                                },
                            })
                            .then((res) => res.data?.message || row)
                            .catch(() => row)
                    )
                );
                setRetailDraftCutoff(cutoff);
                setRetailDraftSales(drafts);
                return drafts;
            })
            .catch((error) => {
                defaultErrorToast(error);
                setRetailDraftSalesError(true);
                setRetailDraftSales([]);
                return [];
            })
            .finally(() => {
                setRetailDraftSalesLoading(false);
            });
    };

    const handleOpenRetailDraftSales = () => {
        setRetailDraftOldOnly(false);
        setRetailDraftSalesOpen(true);
        fetchRetailDraftSales();
    };

    const handleDeleteRetailDraftSale = (event, draft) => {
        event.stopPropagation();
        if (!draft?.name || deleteOrderMutation.isLoading) return;
        setRetailDraftToDelete(draft);
    };

    const handleConfirmDeleteRetailDraftSale = () => {
        if (!retailDraftToDelete?.name || deleteOrderMutation.isLoading) return;
        handleDeleteOrder(
            { orderId: retailDraftToDelete.name, notes: "", waste: false },
            {
                onSuccess: () => {
                    setRetailDraftToDelete(null);
                    fetchRetailDraftSales();
                },
            }
        );
    };

    const hasRetailActiveSale = useMemo(
        () =>
            !!selectedOrder?.name ||
            (items || []).length > 0 ||
            (savedItems || []).length > 0 ||
            (tmpOrderItems || []).length > 0,
        [items, savedItems, selectedOrder?.name, tmpOrderItems]
    );

    const loadRetailDraftSale = (draft) => {
        if (!draft?.name) return;
        const requestId = ++retailOrderRequestRef.current;
        setRetailDraftSalesLoading(true);
        axios
            .get("method/frappe.client.get", {
                params: {
                    doctype: "Table Order",
                    name: draft.name,
                },
            })
            .then(({ data }) => {
                if (retailOrderRequestRef.current !== requestId) return;
                if (!data?.message) return;
                setSelectedOrder(data.message);
                setOrders((current) => {
                    const list = Array.isArray(current) ? current : [];
                    const withoutCurrent = list.filter(
                        (order) => order?.name !== data.message.name
                    );
                    return [data.message, ...withoutCurrent];
                });
                updateOrderItems(data.message.entry_items);
                setTmpOrderItems([]);
                setItems([]);
                setHasDraftPendingChanges(false);
                setRetailDraftSalesOpen(false);
            })
            .catch((error) => {
                if (retailOrderRequestRef.current === requestId) {
                    defaultErrorToast(error);
                }
            })
            .finally(() => {
                if (retailOrderRequestRef.current === requestId) {
                    setRetailDraftSalesLoading(false);
                }
            });
    };

    const handleSelectRetailDraftSale = (draft) => {
        if (
            isRetailPos &&
            hasRetailActiveSale &&
            draft?.name !== selectedOrder?.name
        ) {
            setPendingRetailDraftSale(draft);
            setRetailDraftReplaceConfirmOpen(true);
            return;
        }

        loadRetailDraftSale(draft);
    };

    const handleConfirmRetailDraftReplace = () => {
        const draft = pendingRetailDraftSale;
        setPendingRetailDraftSale(null);
        setRetailDraftReplaceConfirmOpen(false);
        loadRetailDraftSale(draft);
    };

    const handleCancelRetailDraftReplace = () => {
        setPendingRetailDraftSale(null);
        setRetailDraftReplaceConfirmOpen(false);
    };

    // Tabs POS enhancement: after Send to kitchen success, auto-open close/payment flow
    useEffect(() => {
        if (!isTabsPos && !isRetailPos) return;
        if (!pendingAutoCloseOrderName) return;
        if (!selectedOrder?.name) return;
        if (selectedOrder.name !== pendingAutoCloseOrderName) return;

        setPendingAutoCloseOrderName(null);
        if (!isCallCenterUser && !isServiceUser) {
            handleCloseTable(selectedOrder, selectedTable);
        }
    }, [isTabsPos, isRetailPos, pendingAutoCloseOrderName, selectedOrder?.name, isCallCenterUser, isServiceUser]);

    const mutateNewOrder = useAddNewOrder();
    const mutatePushOrderItems = usePushOrderItems();
    const mutateNewOrderDraft = useAddNewOrderDraft();
    const mutatePushOrderItemsDraft = usePushOrderItemsDraft();
    const sendDraftOrderMutation = useSendTableOrder();

    const isSendingToKitchen =
        mutateNewOrder.isLoading || mutatePushOrderItems.isLoading;
    const isSavingDraft =
        mutateNewOrderDraft.isLoading || mutatePushOrderItemsDraft.isLoading;
    const isSendingDraftOrder = sendDraftOrderMutation.isLoading;
    const shouldSkipPrintAfterDuplicate =
        isFromCancelDuplicate &&
        Number(restaurantSettings?.docs?.[0]?.print_after_duplicate) !== 1;
    const isOrderMetadataPromptMode = isTabsPos || isCallCenterUser;

    const handleSaveToTable = async (
        table,
        { startNewRetailSaleAfterSave = false, retail_metadata, onNotesSaved } = {}
    ) => {
        const newOrderItems = [];
        tmpOrderItems.map((i) => {
            newOrderItems.push({
                identifier: i.item?.identifier || i.identifier,
                addons: (i.addons || [])
                    .map(mapAddonToOrderItemPayload)
                    .filter(Boolean),
                qty: i.qty,
                item: i.item.item_code,
                notes: i.notes,
                standard_rate: i.item.standard_rate,
            });
        });

        const rateChanged = [];

        // selectedOrder;

        newOrderItems.map((i) => {
            const menuItem = (menuItems || []).find(
                (item) => item.item_code === i.item
            );
            if (menuItem) {
                if (menuItem.standard_rate !== i.standard_rate) {
                    rateChanged.push({
                        ...i,
                        originalRate: menuItem.standard_rate,
                    });
                }
            }
        });

        if (selectedOrder) {
            mutatePushOrderItems.mutate(
                {
                    retail_metadata,
                    orderItems: newOrderItems,
                    order: selectedOrder,
                    elevatedPrivileges:
                        passwordRestrictions.price && rateChanged.length > 0,
                    elevatedText: rateChanged.length > 0 ? "Rate Changed" : "",
                },
                {
                    onSuccess: () => {
                        onNotesSaved?.();
                        if (isRetailPos) {
                            refetchMenuItems();
                        }
                        refetchTablesData().then((res) => {
                            if (isTabsPos) {
                                const payload = res?.data?.message || {};
                                const allTables = [
                                    payload.takeaway,
                                    ...Object.values(payload.rooms || {}).flatMap(
                                        (room) => Object.values(room?.tables || {})
                                    ),
                                ].filter(Boolean);
                                const refreshedOrder = allTables
                                    .flatMap((table) => Object.values(table?.orders || {}))
                                    .find((order) => order?.name === orderName);
                                updateOrderItems(
                                    refreshedOrder?.entry_items
                                );

                                setTmpOrderItems([]);
                                setItems([]);
                            }
                        });

                        if (isRetailPos) {
                            handleRetailOrderSent(selectedOrder?.name, {
                                startNewRetailSaleAfterSave,
                            });
                        } else if (isTabsPos) {
                            // Auto open close/payment flow after kitchen send (OrderTabs flow)
                            if (!isCallCenterUser && !isServiceUser) {
                                handleCloseTable(selectedOrder, selectedTable);
                            }
                        } else {
                            navigateHome();
                        }
                    },
                    onError: (error) => {
                        isRetailPos ? handleRetailStockError(error) : defaultErrorToast(error);
                    },
                }
            );
        } else {
            let promptData = null;
            if (!isRetailPos && (restaurantSettings?.docs[0]?.mandatory_notes == 1 || isCallCenterUser)) {
                const reservedDesignatedNumbers = isOrderMetadataPromptMode
                    ? await fetchReservedDesignatedNumbers()
                    : [];
                const prefilledPromptCustomer =
                    isTabsPos &&
                    selectedCustomer &&
                    selectedCustomer !== defaultTakeawayCustomer
                        ? selectedCustomer
                        : "";

                promptData = await showReservationPrompt({
                    title: t("pos.orderNotesTitle"),
                    message: t("pos.orderNotesPrompt"),
                    confirmText: t("pos.createOrder"),
                    cancelText: t("common.cancel"),
                    isTabsPos: isOrderMetadataPromptMode,
                    enableExpectedStartTime: Number(posProfile?.rm_enable_expected_start_time) === 1,
                    isCallCenterUser,
                    reservedDesignatedNumbers,
                    initialData: {
                        customer: prefilledPromptCustomer,
                    },
                });

                if (!promptData) return;
            }

            const notesText = promptData?.notes || "";

            mutateNewOrder.mutate(
                {
                    retail_metadata,
                    orderItems: newOrderItems,
                    table: selectedTable.name,
                    customer: isOrderMetadataPromptMode
                        ? promptData?.customer || selectedCustomer
                        : selectedCustomer,
                    address: isOrderMetadataPromptMode ? undefined : selectedAddress,
                    address_line1: isOrderMetadataPromptMode
                        ? promptData?.address_line1
                        : undefined,
                    address_line2: isOrderMetadataPromptMode
                        ? promptData?.address_line2
                        : undefined,
                    customer_details: isOrderMetadataPromptMode
                        ? promptData?.customer_details
                        : undefined,
                    mobile_no: isOrderMetadataPromptMode ? promptData?.mobile_no : undefined,
                    delivery_provider: isOrderMetadataPromptMode
                        ? promptData?.delivery_provider
                        : undefined,
                    dinners: isOrderMetadataPromptMode ? undefined : promptData?.adults,
                    dinners_children: isOrderMetadataPromptMode
                        ? undefined
                        : promptData?.kids,
                    dinners_infants: isOrderMetadataPromptMode
                        ? undefined
                        : promptData?.babies,
                    expected_start_time: promptData?.expected_start_time,
                    estimated_preparation_time: isOrderMetadataPromptMode
                        ? promptData?.estimated_preparation_time
                        : undefined,
                    designated_number: isOrderMetadataPromptMode
                        ? promptData?.designated_number || undefined
                        : undefined,
                    notes: notesText,
                    call_center_order: isCallCenterUser ? 1 : undefined,
                    elevatedPrivileges:
                        passwordRestrictions.price && rateChanged.length > 0,
                    elevatedText:
                        rateChanged.length > 0 ? t("pos.rateChanged") : "",
                },
                {
                    onSuccess: (res) => {
                        onNotesSaved?.();
                        // Ensure any newly created customer/address shows up across the app (OrderTabs cards, dialogs, etc.)
                        refetchCustomers?.();
                        refetchAddresses?.();
                        if (isRetailPos) {
                            refetchMenuItems();
                            refetchTablesData().then(() => {
                                handleRetailOrderSent(res.message, {
                                    startNewRetailSaleAfterSave,
                                });
                            });
                        } else if (isTakeaway) {
                            refetchTablesData().then(() => {
                                setTmpOrderItems([]);
                                if (isTabsPos && !isServiceUser) {
                                    // After navigation, selectedOrder will be loaded; then we auto-open close/payment
                                    setPendingAutoCloseOrderName(res.message);
                                }
                                navigate(
                                    `/pos/${takeawayPathSegment}/${res.message}`
                                );
                            });
                        } else {
                            refetchTablesData();
                            navigateHome();
                        }
                    },
                    onError: (error) => {
                        isRetailPos ? handleRetailStockError(error) : defaultErrorToast(error);
                    },
                }
            );
        }
        return;
    };

    const handleSaveRetailCartAndStartNewSale = () => {
        if (!selectedTable || !hasRetailDirtyCart) return;
        setRetailNewSaleConfirmOpen(false);
        handleSaveToTable(selectedTable, {
            startNewRetailSaleAfterSave: true,
        });
    };

    const handleSaveDraftToTable = async (table, options = {}) => {
        const hasProvidedPromptData = Object.prototype.hasOwnProperty.call(
            options,
            "promptData"
        );
        const providedPromptData = hasProvidedPromptData
            ? options.promptData
            : null;
        const newOrderItems = [];
        tmpOrderItems.map((i) => {
            newOrderItems.push({
                identifier: i.item?.identifier || i.identifier,
                addons: (i.addons || [])
                    .map(mapAddonToOrderItemPayload)
                    .filter(Boolean),
                qty: i.qty,
                item: i.item.item_code,
                notes: i.notes,
                standard_rate: i.item.standard_rate,
            });
        });

        const rateChanged = [];
        newOrderItems.map((i) => {
            const menuItem = (menuItems || []).find(
                (item) => item.item_code === i.item
            );
            if (menuItem) {
                if (menuItem.standard_rate !== i.standard_rate) {
                    rateChanged.push({
                        ...i,
                        originalRate: menuItem.standard_rate,
                    });
                }
            }
        });

        // Kiosk cash orders remain a single-step flow. Other POS modes show
        // this dialog when notes or their draft metadata workflow requires it.
        let promptData = providedPromptData;
        if (
            !hasProvidedPromptData &&
            !isRetailPos &&
            !isKioskMode &&
            (
                restaurantSettings?.docs[0]?.mandatory_notes == 1 ||
                isTabsPos ||
                isCallCenterUser
            )
        ) {
            const reservedDesignatedNumbers = isOrderMetadataPromptMode
                ? await fetchReservedDesignatedNumbers()
                : [];

            // Pre-fill with existing order data if updating an existing draft
            const initialData = selectedOrder ? {
                notes: selectedOrder.notes || "",
                adults: selectedOrder.dinners || "",
                kids: selectedOrder.dinners_children || "",
                babies: selectedOrder.dinners_infants || "",
                expected_start_time: selectedOrder.expected_start_time || "",
                estimated_preparation_time: selectedOrder.estimated_preparation_time || 15,
                alert_after_minutes: selectedOrder.alert_after_minutes || "",
                designated_number: selectedOrder.designated_number || "",
                customer: selectedOrder.customer || "",
                mobile_no: selectedOrder.mobile_no || "",
                address_line1: selectedOrder.address_line1 || "",
                address_line2: selectedOrder.address_line2 || "",
                delivery_provider: selectedOrder.delivery_provider || "",
                use_delivery_provider: !!selectedOrder.delivery_provider,
                is_existing_draft: isDraftTableOrder(selectedOrder),
            } : undefined;

            promptData = await showReservationPrompt({
                title: t("pos.orderNotesTitle"),
                message: t("pos.orderNotesPrompt"),
                confirmText: selectedOrder ? t("common.save") : t("pos.createOrder"),
                cancelText: t("common.cancel"),
                isTabsPos: isOrderMetadataPromptMode,
                enableExpectedStartTime: Number(posProfile?.rm_enable_expected_start_time) === 1,
                isCallCenterUser,
                enableDraftAlert: true,
                reservedDesignatedNumbers,
                initialData,
            });

            if (!promptData) return;
        }

        const notesText = promptData?.notes || "";

        if (selectedOrder) {
            // If dialog was shown and user provided data, update order metadata first
            const shouldUpdateMetadata =
                promptData &&
                !isRetailPos &&
                (restaurantSettings?.docs[0]?.mandatory_notes == 1 ||
                    isOrderMetadataPromptMode);
            let refreshedCustomerFallback = selectedOrder.customer || "";
            
            if (shouldUpdateMetadata) {
                try {
                    // Build update payload based on mode
                    const metadataPayload = {
                        notes: notesText,
                        ...(promptData.expected_start_time !== undefined
                            ? { expected_start_time: promptData.expected_start_time }
                            : {}),
                    };
                    let resolvedCustomer = "";

                    if (isOrderMetadataPromptMode) {
                        resolvedCustomer = promptData.customer || "";
                        if (resolvedCustomer) {
                            const { data } = await axios.post(
                                "method/restaurant_management.api.resolve_customer_for_order",
                                {
                                    customer: resolvedCustomer,
                                    mobile_no: promptData.mobile_no || "",
                                    customer_details:
                                        promptData.customer_details ?? undefined,
                                }
                            );
                            if (data?.message?.customer) {
                                resolvedCustomer = data.message.customer;
                            }
                        }

                        metadataPayload.estimated_preparation_time = promptData.estimated_preparation_time;
                        metadataPayload.alert_after_minutes = promptData.alert_after_minutes || "";
                        metadataPayload.alert_time = promptData.alert_time || "";
                        metadataPayload.designated_number = promptData.designated_number || "";
                        metadataPayload.customer = resolvedCustomer;
                        metadataPayload.mobile_no = promptData.mobile_no || "";
                        metadataPayload.address_line1 = promptData.address_line1 || "";
                        metadataPayload.address_line2 = promptData.address_line2 || "";
                        metadataPayload.delivery_provider = promptData.delivery_provider || "";
                    } else {
                        if (promptData.adults !== undefined) metadataPayload.dinners = promptData.adults;
                        if (promptData.kids !== undefined) metadataPayload.dinners_children = promptData.kids;
                        if (promptData.babies !== undefined) metadataPayload.dinners_infants = promptData.babies;
                    }

                    // Update order metadata using axios directly
                    await axios.post("method/frappe.client.set_value", {
                        doctype: getOrderDoctype(selectedOrder),
                        name: selectedOrder.name,
                        fieldname: metadataPayload,
                    });

                    if (isOrderMetadataPromptMode) {
                        refreshedCustomerFallback = resolvedCustomer || "";
                        setSelectedCustomer(resolvedCustomer || "");
                        setSelectedOrder((current) =>
                            current?.name === selectedOrder.name
                                ? {
                                      ...current,
                                      ...metadataPayload,
                                      customer: resolvedCustomer || "",
                                  }
                                : current
                        );
                        await Promise.all([
                            refetchCustomers?.(),
                            refetchAddresses?.(),
                        ]);
                    }
                } catch (error) {
                    defaultErrorToast(error);
                    return;
                }
            }
            
            mutatePushOrderItemsDraft.mutate(
                {
                    orderItems: buildDraftOrderItemsPayload({
                        includeSavedItems: true,
                    }),
                    order: selectedOrder,
                    replaceExisting: true,
                    elevatedPrivileges:
                        passwordRestrictions.price && rateChanged.length > 0,
                    elevatedText:
                        rateChanged.length > 0 ? t("pos.rateChanged") : "",
                },
                {
                    onSuccess: () => {
                        if (shouldUpdateMetadata) {
                            refetchCustomers?.();
                            refetchAddresses?.();
                        }
                        enqueueSnackbar(t("pos.savedAsDraft"), {
                            variant: "success",
                        });

                        // Draft orders are NOT in floor data, so re-fetch the
                        // draft doc directly to get the updated entry_items.
                        const doctype = getOrderDoctype(selectedOrder);
                        axios
                            .get("method/frappe.client.get", {
                                params: {
                                    doctype,
                                    name: selectedOrder.name,
                                },
                            })
                            .then(({ data }) => {
                                if (data?.message) {
                                    setSelectedOrder(data.message);
                                    setSelectedCustomer(
                                        data.message.customer ||
                                            refreshedCustomerFallback ||
                                            ""
                                    );
                                    setSelectedAddress(data.message.address || null);
                                    updateOrderItems(
                                        data.message.entry_items
                                    );
                                }
                            })
                            .finally(() => {
                                setTmpOrderItems([]);
                                setItems([]);
                                setHasDraftPendingChanges(false);
                            });
                    },
                    onError: (error) => {
                        defaultErrorToast(error);
                    },
                }
            );
        } else {
            mutateNewOrderDraft.mutate(
                {
                    orderItems: newOrderItems,
                    table: selectedTable.name,
                    customer: isOrderMetadataPromptMode
                        ? promptData?.customer || selectedCustomer
                        : selectedCustomer,
                    address: isOrderMetadataPromptMode ? undefined : selectedAddress,
                    address_line1: isOrderMetadataPromptMode
                        ? promptData?.address_line1
                        : undefined,
                    address_line2: isOrderMetadataPromptMode
                        ? promptData?.address_line2
                        : undefined,
                    customer_details: isOrderMetadataPromptMode
                        ? promptData?.customer_details
                        : undefined,
                    mobile_no: isOrderMetadataPromptMode ? promptData?.mobile_no : undefined,
                    delivery_provider: isOrderMetadataPromptMode
                        ? promptData?.delivery_provider
                        : undefined,
                    dinners: isOrderMetadataPromptMode ? undefined : promptData?.adults,
                    dinners_children: isOrderMetadataPromptMode
                        ? undefined
                        : promptData?.kids,
                    dinners_infants: isOrderMetadataPromptMode
                        ? undefined
                        : promptData?.babies,
                    expected_start_time: promptData?.expected_start_time,
                    estimated_preparation_time: isOrderMetadataPromptMode
                        ? promptData?.estimated_preparation_time
                        : undefined,
                    alert_after_minutes: isOrderMetadataPromptMode
                        ? promptData?.alert_after_minutes || undefined
                        : undefined,
                    alert_time: isOrderMetadataPromptMode
                        ? promptData?.alert_time || undefined
                        : undefined,
                    designated_number: isOrderMetadataPromptMode
                        ? promptData?.designated_number || undefined
                        : undefined,
                    notes: notesText,
                    call_center_order: isCallCenterUser ? 1 : undefined,
                    elevatedPrivileges:
                        passwordRestrictions.price && rateChanged.length > 0,
                    elevatedText:
                        rateChanged.length > 0 ? t("pos.rateChanged") : "",
                },
                {
                    onSuccess: (res) => {
                        // Ensure any newly created customer/address shows up across the app (OrderTabs cards, dialogs, etc.)
                        refetchCustomers?.();
                        refetchAddresses?.();
                        if (isKioskMode) {
                            setKioskCashReceipt(res.message);
                            setTmpOrderItems([]);
                            setItems([]);
                            setSavedItems([]);
                            setSelectedOrder(null);
                            setHasDraftPendingChanges(false);
                            refetchTablesData();
                            enqueueSnackbar(
                                t("kiosk.orderReceived", {
                                    number: getOrderShortName(res.message),
                                }),
                                { variant: "success" }
                            );
                            // Stay on this screen until the customer acknowledges
                            // their order number and the receipt has been requested.
                            return;
                        }
                        enqueueSnackbar(t("pos.savedAsDraft"), {
                            variant: "success",
                        });
                        if (isRetailPos) {
                            setTmpOrderItems([]);
                            setItems([]);
                            setSavedItems([]);
                            setSelectedOrder(null);
                            setHasDraftPendingChanges(false);
                            fetchRetailDraftSales();
                            navigate("/pos", { replace: true });
                            return;
                        }
                        // In tabs POS, drafts won't show in floor data (filtered), so return to OrderTabs
                        if (isTabsPos) {
                            setTmpOrderItems([]);
                            setItems([]);
                            navigateHome();
                            return;
                        }

                        if (isTakeaway) {
                            refetchTablesData().then(() => {
                                setTmpOrderItems([]);
                                navigate(
                                    `/pos/${takeawayPathSegment}/${res.message}`
                                );
                            });
                        } else {
                            refetchTablesData();
                            navigateHome();
                        }
                    },
                    onError: (error) => {
                        defaultErrorToast(error);
                    },
                }
            );
        }
        return;
    };

    const handleSendDraftOrder = async () => {
        if (!selectedOrder?.name) return;

        // Show dialog if mandatory notes are enabled
        let promptData = null;
        if (!isRetailPos && (restaurantSettings?.docs[0]?.mandatory_notes == 1 || isCallCenterUser)) {
            const reservedDesignatedNumbers = isOrderMetadataPromptMode
                ? await fetchReservedDesignatedNumbers()
                : [];

            promptData = await showReservationPrompt({
                title: t("pos.orderNotesTitle"),
                message: t("pos.orderNotesPrompt"),
                confirmText: t("pos.sendToKitchen"),
                showSaveDraftButton: true,
                saveDraftText: t("common.save"),
                cancelText: t("common.cancel"),
                isTabsPos: isOrderMetadataPromptMode,
                enableExpectedStartTime: Number(posProfile?.rm_enable_expected_start_time) === 1,
                isCallCenterUser,
                enableDraftAlert: true,
                reservedDesignatedNumbers,
                // Pre-fill with existing order data
                initialData: {
                    notes: selectedOrder.notes || "",
                    adults: selectedOrder.dinners || "",
                    kids: selectedOrder.dinners_children || "",
                    babies: selectedOrder.dinners_infants || "",
                    expected_start_time: selectedOrder.expected_start_time || "",
                    estimated_preparation_time: selectedOrder.estimated_preparation_time || 15,
                    alert_after_minutes: selectedOrder.alert_after_minutes || "",
                    designated_number: selectedOrder.designated_number || "",
                    customer: selectedOrder.customer || "",
                    mobile_no: selectedOrder.mobile_no || "",
                    address_line1: selectedOrder.address_line1 || "",
                    address_line2: selectedOrder.address_line2 || "",
                    delivery_provider: selectedOrder.delivery_provider || "",
                    use_delivery_provider: !!selectedOrder.delivery_provider,
                    is_existing_draft: isDraftTableOrder(selectedOrder),
                },
            });

            if (!promptData) return;
            if (promptData?.__action === "save_draft") {
                await handleSaveDraftToTable(selectedTable, { promptData });
                return;
            }
        }

        const orderItems = buildDraftOrderItemsPayload({
            includeSavedItems: true,
        });

        // Resolve metadata -- prefer promptData values, fallback to selectedOrder
        const customer = promptData?.customer || selectedOrder.customer || "";
        const notes = promptData?.notes ?? selectedOrder.notes ?? "";
        const dinners = promptData?.adults ?? selectedOrder.dinners ?? 0;
        const dinners_children = promptData?.kids ?? selectedOrder.dinners_children ?? 0;
        const dinners_infants = promptData?.babies ?? selectedOrder.dinners_infants ?? 0;
        const estimated_preparation_time =
            promptData?.estimated_preparation_time ??
            selectedOrder.estimated_preparation_time ??
            undefined;
        const designated_number =
            promptData?.designated_number ?? selectedOrder.designated_number ?? undefined;
        const delivery_provider =
            promptData?.delivery_provider ?? selectedOrder.delivery_provider ?? undefined;
        const mobile_no = promptData?.mobile_no ?? selectedOrder.mobile_no ?? undefined;
        const address_line1 =
            promptData?.address_line1 ?? selectedOrder.address_line1 ?? undefined;
        const address_line2 =
            promptData?.address_line2 ?? selectedOrder.address_line2 ?? undefined;
        const customer_details = promptData?.customer_details ?? undefined;

        sendDraftOrderMutation.mutate(
            {
                table: selectedOrder.table,
                draftName: selectedOrder.name,
                orderItems,
                customer,
                address: selectedOrder.address || undefined,
                mobile_no,
                address_line1,
                address_line2,
                customer_details,
                dinners,
                dinners_children,
                dinners_infants,
                notes,
                expected_start_time: promptData?.expected_start_time ?? selectedOrder.expected_start_time,
                estimated_preparation_time,
                designated_number,
                delivery_provider,
                call_center_order: isCallCenterUser ? 1 : undefined,
                no_print: shouldSkipPrintAfterDuplicate ? true : undefined,
            },
            {
                onSuccess: (res) => {
                    enqueueSnackbar(t("pos.draftSaved"), { variant: "success" });
                    // The backend created a new Table Order and marked the draft as Attending.
                    // Navigate to the new order if the backend returned its name.
                    const newOrderName = res?.message;
                    if (newOrderName && typeof newOrderName === "string") {
                        refetchTablesData?.().then(() => {
                            setTmpOrderItems([]);
                            setHasDraftPendingChanges(false);
                            if (isTabsPos && !isServiceUser) {
                                // Auto-open payment dialog after navigating to the new order
                                setPendingAutoCloseOrderName(newOrderName);
                            }
                            if (isRetailPos) {
                                handleRetailOrderSent(newOrderName);
                            } else if (isTakeaway) {
                                navigate(
                                    `/pos/${takeawayPathSegment}/${newOrderName}`
                                );
                            } else {
                                navigateHome();
                            }
                        });
                    } else {
                        setHasDraftPendingChanges(false);
                        refetchTablesData?.();
                        navigateHome();
                    }
                },
                onError: (error) => {
                    defaultErrorToast(error);
                },
            }
        );
    };

    const handleCloseDialog = () => {
        setWidgetsDialogsOpen(false);
        setToCloseTable(null);
    };

    const handleAddServiceOrder = () => {
        if (!isServiceUser) return;

        handleCloseDialog();
        setSelectedOrder(null);
        setSavedItems([]);
        setTmpOrderItems([]);
        setItems([]);
        setHasDraftPendingChanges(false);
        navigate(isRetailPos ? "/pos" : `/pos/${takeawayPathSegment}`, {
            replace: isRetailPos,
        });
    };

    const [kioskCardRequested, setKioskCardRequested] = useState(false);
    const [kioskCashReceipt, setKioskCashReceipt] = useCashReceipt(posProfile?.name, userInfo?.name);

    const handleStartNewKioskOrder = () => {
        setSelectedOrder(null);
        setSavedItems([]);
        setTmpOrderItems([]);
        setItems([]);
        setHasDraftPendingChanges(false);
        navigate(`/kiosk/${takeawayPathSegment}`, { replace: true });
    };

    const handleItemDelete = (orderItem, props) => {
        setTmpOrderItems((current) =>
            current.filter((item) => item.entry_name !== orderItem.entry_name)
        );
    };

    const [itemDeleting, setItemDeleting] = useState(false);
    const [deletingItemIdentifier, setDeletingItemIdentifier] = useState(null);

    const handleDeleteOrder = (payload, callbacks = {}) => {
        if (!payload?.orderId || deleteOrderMutation.isLoading) return;
        const isDeletingActiveRetailOrder =
            isRetailPos && selectedOrder?.name === payload.orderId;

        const mutationPayload = {
            orderId: payload.orderId,
            notes: payload.notes || "",
            waste: !!payload.waste,
            doctype: getOrderDoctype(payload.orderId),
        };

        if (payload.masterPassword) {
            mutationPayload.masterPassword = payload.masterPassword;
        }

        deleteOrderMutation.mutate(mutationPayload, {
            onSuccess: () => {
                if (isDeletingActiveRetailOrder) {
                    setSelectedOrder(null);
                    setOrders((current) =>
                        Array.isArray(current)
                            ? current.filter(
                                  (order) => order?.name !== payload.orderId
                              )
                            : current
                    );
                    setItems([]);
                    setHasDraftPendingChanges(false);
                }
                if (!isRetailPos || isDeletingActiveRetailOrder) {
                    setSavedItems([]);
                    setTmpOrderItems([]);
                }
                refetchTablesData();
                if (isRetailPos) {
                    refetchMenuItems();
                }
                enqueueSnackbar(t("pos.orderDeletedSuccessfully"), {
                    variant: "success",
                });
                if (!isRetailPos || isDeletingActiveRetailOrder) {
                    navigateHome();
                }
                callbacks?.onSuccess?.();
            },
            onError: (error) => {
                defaultErrorToast(error);
                callbacks?.onError?.(error);
            },
            onSettled: (data, error) => {
                callbacks?.onSettled?.(data, error);
            },
        });
    };

    const handleSubmittedItemDelete = (orderItem, password, qty, notes, waste) => {
        setItemDeleting(true);
        setDeletingItemIdentifier(
            orderItem?.item?.identifier || orderItem?.entry_name || null
        );

        // If this deletion would leave the cart empty, delete the whole order
        // instead of deleting the last entry item.
        const orderItemIdentifier = orderItem?.item?.identifier;
        const qtyToDelete =
            qty ??
            orderItem?.qty ??
            orderItem?.item?.qty ??
            orderItem?.item?.quantity ??
            0;

        const remainingSavedItems = [];
        if (savedItems && savedItems.length > 0) {
            savedItems.forEach((i) => {
                const sameIdentifier =
                    i?.item?.identifier && orderItemIdentifier
                        ? i.item.identifier === orderItemIdentifier
                        : false;

                if (!sameIdentifier) {
                    remainingSavedItems.push(i);
                    return;
                }

                const currentQty =
                    i?.qty ?? i?.item?.qty ?? i?.item?.quantity ?? 0;
                const nextQty = Number(currentQty) - Number(qtyToDelete);

                if (nextQty > 0) {
                    remainingSavedItems.push({
                        ...i,
                        qty: nextQty,
                    });
                }
            });
        }

        const willCartBeEmpty =
            (!items || items.length === 0) && remainingSavedItems.length === 0;

        if (willCartBeEmpty && selectedOrder?.name) {
            const payload = {
                orderId: selectedOrder.name,
                notes: notes || "",
                waste: !!waste,
            };

            if (!isDraftTableOrder(selectedOrder) && passwordRestrictions.cancellation) {
                payload.masterPassword = password;
            }

            // Keep per-item deleting UI visible until navigation
            handleDeleteOrder(payload, {
                onSettled: () => {
                    setItemDeleting(false);
                },
            });
            return;
        }

        const orderDoctype = getOrderDoctype(selectedOrder);

        const removeOrderItemPayload = {
            orderId: selectedOrder.name,
            item: orderItem.item,
            doctype: orderDoctype,
        };

        if (!isDraftTableOrder(selectedOrder) && passwordRestrictions.cancellation) {
            removeOrderItemPayload.masterPassword = password;
        }

        if (qty) {
            removeOrderItemPayload.qty = qty;
        }

        if (waste) {
            removeOrderItemPayload.waste = waste;
        }

        removeOrderItemMutation.mutate(removeOrderItemPayload, {
            onSuccess: async () => {
                refetchTablesData();
                if (isRetailPos) {
                    refetchMenuItems();
                }

                const newSavedItems = [];
                savedItems.forEach((i) => {
                    if (i.item.identifier === orderItem.item.identifier) {
                        if (i.item.qty > qty) {
                            newSavedItems.push({
                                ...i,
                                qty: i.item.qty - qty,
                            });
                        }
                    } else {
                        newSavedItems.push(i);
                    }
                });

                setSavedItems(newSavedItems);

                // Only auto-delete the order if cart is truly empty
                if (newSavedItems.length === 0 && (!items || items.length === 0)) {
                    const deletedOrderName = selectedOrder.name;
                    try {
                        await deleteDoc({
                            doctype: orderDoctype,
                            name: deletedOrderName,
                        });
                        if (isRetailPos) {
                            setSelectedOrder(null);
                            setOrders((current) =>
                                Array.isArray(current)
                                    ? current.filter(
                                          (order) =>
                                              order?.name !== deletedOrderName
                                      )
                                    : current
                            );
                            setHasDraftPendingChanges(false);
                        }
                        refetchTablesData();
                        navigateHome();
                    } catch (error) {
                        defaultErrorToast(error);
                    }
                }
            },
            onError: (error) => {
                // defaultErrorToast(error);
            },
            onSettled: () => {
                setItemDeleting(false);
                setDeletingItemIdentifier(null);
            },
        });
    };

    // Define the event handler function
    const handleItemEdit = (orderItem) => {
        setEditedOrderItem(orderItem);
        setAddedItem(orderItem.item);
        setEditOrderItemOpen(true);
    };

    const [splitItem, setSplitItem] = useState(null);

    const handleItemSplit = (orderItem) => {
        if (!orderItem) return;
        setSplitItem(orderItem);
    };

    const handleSplitItemConfirm = (qtys) => {
        if (!splitItem || !Array.isArray(qtys) || qtys.length < 2) {
            setSplitItem(null);
            return;
        }

        // Match the exact cart entry. Menu item identifiers can be shared by
        // duplicate entries, while entry_name is unique per cart row.
        const matchesSource = (i) => {
            const sourceEntryName = splitItem?.entry_name;
            if (sourceEntryName) return i?.entry_name === sourceEntryName;

            const sourceId = splitItem?.item?.identifier;
            return !!sourceId && i?.item?.identifier === sourceId;
        };

        const buildSplitEntries = (entry) =>
            qtys.map((qty) => {
                const newIdentifier = "entry_" + uuidv4();
                // Re-clone addons so each split owns its own addon entries
                // (new identifier, new parent_item pointer, qty matching the
                // split). Reuse cloneAddOn so qty/rate semantics stay
                // identical to the rest of the cart.
                const clonedAddons = (entry.addons || []).map((addon) =>
                    cloneAddOn(
                        addon,
                        qty,
                        newIdentifier,
                        addon?.standard_rate != null
                            ? Number(addon.standard_rate)
                            : null,
                        entry.qty,
                        false
                    )
                );

                return {
                    ...entry,
                    item: {
                        ...entry.item,
                        identifier: newIdentifier,
                        qty,
                    },
                    addons: clonedAddons,
                    qty,
                    entry_name: newIdentifier,
                };
            });

        let didSplitTmp = false;
        setTmpOrderItems((prev) => {
            const next = [];
            prev.forEach((entry) => {
                if (!matchesSource(entry)) {
                    next.push(entry);
                    return;
                }
                didSplitTmp = true;
                next.push(...buildSplitEntries(entry));
            });
            return next;
        });

        if (!didSplitTmp && isDraftTableOrder(selectedOrder)) {
            setSavedItems((prev) => {
                let didSplitSaved = false;
                const next = [];
                (prev || []).forEach((entry) => {
                    if (!matchesSource(entry)) {
                        next.push(entry);
                        return;
                    }
                    didSplitSaved = true;
                    next.push(...buildSplitEntries(entry));
                });

                if (didSplitSaved) {
                    setHasDraftPendingChanges(true);
                }

                return next;
            });
        }

        setSplitItem(null);
    };

    const onItemsLoaded = (items) => {
        setMenuItems1(items);
    };

    useEffect(() => {
        setHasDraftPendingChanges(false);
    }, [selectedOrder?.name]);

    const retailHeaderActions = useMemo(() => {
        if (!isRetailPos || isRetailServiceUser) return [];

        return [
            {
                key: "loyalty",
                label: t("speedDial.loyalty"),
                icon: <Stars fontSize="small" />,
                onClick: () => setRetailLoyaltyOpen(true),
            },
            {
                key: "cash-out",
                label: t("speedDial.cashOut"),
                icon: <ShoppingCartCheckout fontSize="small" />,
                onClick: () => setRetailCashOutOpen(true),
            },
            ...(canUseInterCompanyStockTransfer
                ? [
                      {
                          key: "stock-transfer",
                          label: t("stockTransfer.action"),
                          icon: <LocalShipping fontSize="small" />,
                          onClick: () => setRetailStockTransferOpen(true),
                      },
                  ]
                : []),
            {
                key: "returns",
                label: t("retailReturn.action"),
                icon: <AssignmentReturn fontSize="small" />,
                onClick: () => setRetailReturnOpen(true),
            },
            ...(!hideClosedOrders
                ? [
                      {
                          key: "sales-report",
                          label: t("retailPos.salesReport"),
                          icon: <Archive fontSize="small" />,
                          onClick: () => setRetailClosedOrdersOpen(true),
                      },
                  ]
                : []),
            {
                key: "close-cash",
                label: t("speedDial.closePosCash"),
                icon: <MoneyOffCsred fontSize="small" />,
                onClick: () => setRetailCloseCashOpen(true),
            }
        ];
    }, [
        canUseInterCompanyStockTransfer,
        hideClosedOrders,
        isRetailPos,
        isRetailServiceUser,
        t,
    ]);

    if (isRetailPos && !isAppLoading && !selectedTable) {
        return (
            <React.Fragment>
                <HelmetMeta title={t("retailPos.helmetTitle")} />
                <Box sx={{ p: 3 }}>
                    <Alert severity="warning">
                        {t("retailPos.defaultTableMissing")}
                    </Alert>
                </Box>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className={classes.NotificationSnackbarIcon}></div>
            <div
                className={classes.PageWrap}
                style={isKioskMode ? { touchAction: "pan-x pan-y" } : undefined}
            >
                <HelmetMeta
                    title={
                        isKioskMode
                            ? t("kiosk.helmetTitle")
                            : isRetailPos
                            ? t("retailPos.helmetTitle")
                            : t("pos.helmetTitle")
                    }
                />
                {isKioskMode ? (
                    <Box
                        sx={{
                            minHeight: 64,
                            px: { xs: 1.5, md: 2.5 },
                            py: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                            borderBottom: "1px solid #e5e7eb",
                            bgcolor: "#fff",
                        }}
                    >
                        <Typography variant="h5" sx={{ fontWeight: 950 }}>
                            {t("kiosk.title")}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Button
                                variant="contained"
                                startIcon={<Add />}
                                onClick={handleStartNewKioskOrder}
                            >
                                {t("kiosk.newOrder")}
                            </Button>
                            <LanguageToggle />
                        </Box>
                    </Box>
                ) : null}
                {/* isTabsPos order switching is handled via "Change Order" in OrderCart */}
                {isRetailPos ? (
                    <Box className={classes.RetailHeader}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 800,
                                    color: "#271D1C",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {t("retailPos.helmetTitle")}
                            </Typography>
                            {isServiceUser ? (
                                <Chip
                                    size="small"
                                    color="secondary"
                                    label={t("pos.serviceRole")}
                                    sx={{ fontWeight: 800 }}
                                />
                            ) : null}
                            {userInfo?.full_name || userInfo?.name ? (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "#6E7187",
                                        fontWeight: 700,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {userInfo.full_name || userInfo.name}
                                </Typography>
                            ) : null}
                            {selectedOrder?.name ? (
                                <Chip
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                    label={`${t("retailPos.saleLabel")}: ${getOrderShortName(selectedOrder.name)}`}
                                />
                            ) : null}
                        </Box>

                        <Box className={classes.RetailHeaderActions}>
                            {hasRetailCartItems && !retailReturnOpen ? (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={handleNewRetailSaleRequest}
                                >
                                    {t("retailPos.newSale")}
                                </Button>
                            ) : null}
                            {retailHeaderActions.map((action) => (
                                <Button
                                    key={action.key}
                                    size="small"
                                    variant={action.key === "sales-report" ? "contained" : "outlined"}
                                    startIcon={action.icon}
                                    onClick={action.onClick}
                                >
                                    {action.label}
                                </Button>
                            ))}
                            <CompanyPicker />
                            <PosProfilePicker />
                            <LanguageToggle />
                            <LogoutButton icon={<Logout />} />
                        </Box>
                    </Box>
                ) : null}
                <div
                    className={classes.NewOrderPage}
                    style={{
                        height: isKioskMode
                            ? "calc(100vh - 64px)"
                            : isRetailPos
                            ? "calc(100vh - 76px)"
                            : undefined,
                        maxHeight: isKioskMode
                            ? "calc(100vh - 64px)"
                            : isRetailPos
                            ? "calc(100vh - 76px)"
                            : undefined,
                        paddingTop: isRetailPos ? "12px" : undefined,
                    }}
                >
                    {!isRetailPos && <div className={classes.Categories}>
                        <div className={"CategoriesList"}>
                            <GroupList
                                onClick={onGroupClicked}
                                isDragDropMode={isDragDropMode}
                            ></GroupList>
                        </div>
                    </div>}
                    <div
                        className={classes.CategoryView}
                        style={{
                            width: isRetailPos ? "auto" : undefined,
                            flex: isRetailPos ? "1 1 auto" : undefined,
                            height: isRetailPos ? "100%" : undefined,
                            maxHeight: isRetailPos ? "100%" : undefined,
                        }}
                    >
                        <Box className={"CategoryView__Header"}>
                            <Box 
                                sx={{
                                    display: "block",
                                }}
                            >
                                {/* Controls Row */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1.5,
                                        gap: 1,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <TextField
                                        inputRef={retailSearchInputRef}
                                        value={searchText}
                                        onChange={handleSearchTextChange}
                                        onKeyDown={handleSearchKeyDown}
                                        size="small"
                                        placeholder={
                                            isRetailPos
                                                ? t("retailPos.searchItemsPlaceholder")
                                                : t("pos.searchItemsPlaceholder")
                                        }
                                        sx={{ 
                                            minWidth: { xs: 140, sm: 180 },
                                            maxWidth: { xs: 200, sm: 250 },
                                            flexGrow: 1,
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        {isRetailPos ? (
                                            <ToggleButtonGroup
                                                size="small"
                                                exclusive
                                                value={itemViewMode}
                                                onChange={(_, nextMode) => {
                                                    handleItemViewModeChange(nextMode);
                                                }}
                                                aria-label={t("retailPos.viewMode")}
                                            >
                                                <ToggleButton value="grid" aria-label={t("retailPos.gridView")}>
                                                    <ViewModuleIcon fontSize="small" />
                                                </ToggleButton>
                                                <ToggleButton value="list" aria-label={t("retailPos.listView")}>
                                                    <ViewListIcon fontSize="small" />
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                        ) : null}
                                        {!isRetailPos && !isKioskMode && <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={isQuickAddMode}
                                                    onChange={(e) =>
                                                        handleQuickAddModeChange(
                                                            e.target.checked
                                                        )
                                                    }
                                                    color="primary"
                                                />
                                            }
                                            label={t("pos.quickAdd")}
                                            sx={{
                                                margin: 0,
                                                "& .MuiFormControlLabel-label": {
                                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                                    fontWeight: 500,
                                                },
                                            }}
                                        />}
                                        {!isKioskMode && <Tooltip
                                            title={
                                                isDragDropMode
                                                    ? t("pos.exitSettingsMode")
                                                    : t("pos.enterSettingsMode")
                                            }
                                        >
                                            <Button
                                                onClick={() =>
                                                    setIsDragDropMode(!isDragDropMode)
                                                }
                                                sx={{
                                                    fontSize: "1.5rem",
                                                    minWidth: "auto",
                                                    padding: { xs: "6px", sm: "8px" },
                                                }}
                                                startIcon={
                                                    isDragDropMode ? (
                                                        <SettingsApplicationsRoundedIcon />
                                                    ) : (
                                                        <SettingsIcon />
                                                    )
                                                }
                                            >
                                                {isDragDropMode ? "" : ""}
                                            </Button>
                                        </Tooltip>}
                                    </Box>
                                </Box>
                                
                                {!isRetailPos && <>
                                {/* Subcategories Row */}
                                <Box
                                    className={"Subcatgories"}
                                    sx={{
                                        height: "50px",
                                        width: "100%",
                                    }}
                                >
                                    {selectedCategory &&
                                    selectedCategory.id !== rootGroupId ? (
                                        <SubGroupList
                                            parentItem={selectedCategory}
                                            onClick={onSubGroupClicked}
                                            isDragDropMode={isDragDropMode}
                                            onSubGroupsLoaded={
                                                setCurrentSubGroups
                                            }
                                        ></SubGroupList>
                                    ) : null}
                                </Box>
                                </>}
                                {isRetailPos && barcodeItemCode ? (
                                    <Box sx={{ mt: 1 }}>
                                        <Chip
                                            size="small"
                                            label={t("retailPos.scanFilter", {
                                                item: barcodeItemCode,
                                            })}
                                            onDelete={() => setBarcodeItemCode(null)}
                                        />
                                    </Box>
                                ) : null}
                            </Box>
                        </Box>
                        <div
                            className={`${classes.CategoryViewWrapper} ${
                                !showRetailCatalog
                                    ? classes.RetailCatalogPlaceholder
                                    : ""
                            }`}
                            style={{
                                overflowY: "auto",
                                overflowX: "hidden",
                            }}
                        >
                            {isRetailPos &&
                            (isMenuItemsFetching ||
                                isRetailItemSearchPending) ? (
                                <CircularProgress size={32} />
                            ) : showRetailCatalog ? (
                                <PosItemList
                                    groupedItems={groupedItems}
                                    subGroups={isRetailPos ? [] : currentSubGroups}
                                    menuItems={menuItems}
                                    onClick={onItemClick}
                                    category={isRetailPos ? null : category}
                                    subCategory={isRetailPos ? null : subCategory}
                                    onItemsLoaded={onItemsLoaded}
                                    isDragDropMode={isDragDropMode}
                                    searchText={searchText}
                                    barcodeItemCode={barcodeItemCode}
                                    viewMode={itemViewMode}
                                    isRetailPos={isRetailPos}
                                />
                            ) : (
                                <img
                                    className={classes.RetailCatalogLogo}
                                    src={retailLogoUrl}
                                    alt=""
                                />
                            )}
                        </div>
                    </div>
                    <div className={classes.Order}>
                        {selectedTable && (
                            <OrderCart
                                selectedOrder={selectedOrder}
                                items={items}
                                savedItems={savedItems}
                                table={selectedTable}
                                isDeletingOrder={deleteOrderMutation.isLoading}
                                onDeleteOrder={handleDeleteOrder}
                                deletingItemIdentifier={deletingItemIdentifier}
                                handleSaveToTable={handleSaveToTable}
                                handleSaveToTableDraft={
                                    isTabsPos || isKioskMode
                                        ? handleSaveDraftToTable
                                        : undefined
                                }
                                handleSendDraftOrder={handleSendDraftOrder}
                                isSendingToKitchen={isSendingToKitchen}
                                isSavingDraft={isSavingDraft}
                                isSendingDraftOrder={isSendingDraftOrder}
                                handleSelectOrder={handleSelectOrder}
                                handleCloseTable={handleCloseTable}
                                // isOrderItemsLoading={isOrderItemsLoading}
                                isTakeaway={isTakeaway}
                                onItemEdit={handleItemEdit}
                                onItemSplit={isRetailPos || isKioskMode ? undefined : handleItemSplit}
                                onItemDelete={handleItemDelete}
                                onSubmittedItemDelete={
                                    handleSubmittedItemDelete
                                }
                                itemDeleting={itemDeleting}
                                hasDraftPendingChanges={hasDraftPendingChanges}
                                isRetailPos={isRetailPos}
                                showNewRetailSale={hasRetailCartItems}
                                onNewRetailSale={handleNewRetailSaleRequest}
                                onOpenRetailDrafts={handleOpenRetailDraftSales}
                                onAddOrder={handleAddServiceOrder}
                                retailReturnActive={retailReturnOpen}
                                retailReturnContent={
                                    retailReturnOpen ? (
                                        <RetailReturnDialog
                                            embedded
                                            open={retailReturnOpen}
                                            onClose={() =>
                                                setRetailReturnOpen(false)
                                            }
                                            posProfile={posProfile}
                                            isAdminRole={isAdminRole}
                                            replacementCartItems={items}
                                            replacementCartBlocked={Boolean(
                                                selectedOrder?.name ||
                                                    savedItems.length
                                            )}
                                            onChangeReplacementQty={
                                                handleRetailReplacementQtyChange
                                            }
                                            onReturned={
                                                handleRetailReturnCompleted
                                            }
                                        />
                                    ) : null
                                }
                                isKioskMode={isKioskMode}
                                onKioskCardPayment={() => setKioskCardRequested(true)}
                            />
                        )}
                    </div>
                </div>
            </div>

            {isKioskMode && kioskCashReceipt && <Dialog open disableEscapeKeyDown maxWidth="sm" fullWidth aria-labelledby="kiosk-cash-confirmation-title" aria-describedby="kiosk-cash-confirmation-instructions">
                <Box p={{ xs: 3, sm: 4 }} textAlign="center">
                    <Typography id="kiosk-cash-confirmation-title" variant="h5" mb={2}>{t("kiosk.orderConfirmed")}</Typography>
                    <Typography color="text.secondary">{t("kiosk.orderNumber")}</Typography>
                    <Typography component="p" variant="h2" dir="ltr" sx={{ fontWeight: 700, my: 1 }}>{getOrderShortName(kioskCashReceipt)}</Typography>
                    <Typography id="kiosk-cash-confirmation-instructions" sx={{ mb: 3 }}>{t("kiosk.payAtCashier")}</Typography>
                    <KioskReceipt transport={posProfile?.rm_kiosk_print_transport} doctype="Draft Table Order" name={kioskCashReceipt} />
                    <Button size="large" sx={{ mt: 3, minHeight: 48, minWidth: 180 }} variant="contained" onClick={() => setKioskCashReceipt(null)}>{t("kiosk.newOrder")}</Button>
                </Box>
            </Dialog>}

            {isKioskMode && posProfile?.name && <KioskCheckout
                profile={posProfile.name}
                printTransport={posProfile.rm_kiosk_print_transport}
                requested={kioskCardRequested}
                items={tmpOrderItems.map(i => ({
                    item: i.item.item_code, qty: i.qty, notes: i.notes,
                    addons: (i.addons || []).map(mapAddonToOrderItemPayload).filter(Boolean),
                }))}
                onClosed={() => setKioskCardRequested(false)}
                onCompleted={handleStartNewKioskOrder}
            />}

            {!isServiceUser ? (
                <WidgetsDialogs
                    open={widgetsDialogsOpen}
                    onClose={handleCloseDialog}
                    order={selectedOrder}
                    table={widgetDialogTable}
                    isTakeaway={isTakeaway}
                    onInvoiceClose={handleInvoiceClosed}
                ></WidgetsDialogs>
            ) : null}

            {!hideClosedOrders && (
                <ClosedOrders
                    open={retailClosedOrdersOpen}
                    onClose={() => setRetailClosedOrdersOpen(false)}
                />
            )}

            {retailCloseCashOpen && (
                <PosCashCloseDialog
                    open={retailCloseCashOpen}
                    onClose={() => setRetailCloseCashOpen(false)}
                />
            )}

            <CashOutDialog
                dialogOpen={retailCashOutOpen}
                onCancel={() => setRetailCashOutOpen(false)}
                onConfirm={() => setRetailCashOutOpen(false)}
            />

            <InterCompanyStockTransferDialog
                open={retailStockTransferOpen}
                onClose={() => setRetailStockTransferOpen(false)}
                companies={companies || []}
                currentCompany={company}
                onCompleted={() => refetchMenuItems()}
            />

            <LoyaltyProgramDrawer
                open={retailLoyaltyOpen}
                onClose={() => setRetailLoyaltyOpen(false)}
                customer={selectedCustomer || selectedOrder?.customer || null}
                company={posProfile?.company}
            />

            <Dialog open={!!retailStockError} onClose={() => setRetailStockError("")} fullWidth maxWidth="sm">
                <DialogTitle>{t("retailPos.insufficientStock")}</DialogTitle>
                <Box sx={{ px: 3, pb: 2, whiteSpace: "pre-line" }}>{retailStockError}</Box>
                <DialogActions><Button onClick={() => setRetailStockError("")}>{t("common.close")}</Button></DialogActions>
            </Dialog>

            <ConfirmationDialog
                open={!!retailDraftToDelete}
                title={t("retailPos.deleteSale")}
                message={t("retailPos.confirmDeleteDraftSale", {
                    order: retailDraftToDelete ? getOrderShortName(retailDraftToDelete.name) : "",
                    customer: retailDraftToDelete?.customer || t("retailPos.saleLabel"),
                })}
                confirmText={t("common.delete")}
                cancelText={t("common.cancel")}
                confirmColor="error"
                loading={deleteOrderMutation.isLoading}
                onConfirm={handleConfirmDeleteRetailDraftSale}
                onClose={() => {
                    if (!deleteOrderMutation.isLoading) setRetailDraftToDelete(null);
                }}
            />

            <Dialog
                open={retailDraftReplaceConfirmOpen}
                onClose={handleCancelRetailDraftReplace}
            >
                <DialogTitle>
                    {t("retailPos.replaceCurrentSaleTitle")}
                </DialogTitle>
                <Box sx={{ px: 3, pb: 1, color: "text.secondary" }}>
                    {t("retailPos.replaceCurrentSaleMessage")}
                </Box>
                <DialogActions>
                    <Button onClick={handleCancelRetailDraftReplace}>
                        {t("common.cancel")}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirmRetailDraftReplace}
                    >
                        {t("common.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={retailNewSaleConfirmOpen}
                onClose={() => setRetailNewSaleConfirmOpen(false)}
            >
                <DialogTitle>{t("retailPos.startNewSaleTitle")}</DialogTitle>
                <Box sx={{ px: 3, pb: 1, color: "text.secondary" }}>
                    {t("retailPos.startNewSaleMessage")}
                </Box>
                <DialogActions>
                    <Button
                        onClick={() => setRetailNewSaleConfirmOpen(false)}
                    >
                        {t("common.cancel")}
                    </Button>
                    <Button color="error" onClick={resetRetailSale}>
                        {t("retailPos.discardCurrentSale")}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSaveRetailCartAndStartNewSale}
                    >
                        {t("retailPos.saveCurrentSale")}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={retailDraftSalesOpen}
                onClose={() => setRetailDraftSalesOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <Box sx={{ p: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1,
                            mb: 1.5,
                        }}
                    >
                        <Box sx={{ fontWeight: 800 }}>
                            {t("retailPos.draftSales")}
                        </Box>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={() => setRetailDraftSalesOpen(false)}
                            >
                                {t("common.back")}
                            </Button>
                            <Button
                                size="small"
                                variant={retailDraftOldOnly ? "contained" : "outlined"}
                                aria-pressed={retailDraftOldOnly}
                                title={t("retailPos.oldDraftsHint")}
                                onClick={() => setRetailDraftOldOnly((current) => !current)}
                            >
                                {t("retailPos.oldDrafts")}
                            </Button>
                        </Box>
                    </Box>
                    <TextField fullWidth size="small" sx={{ mb: 2 }}
                        label={t("retailPos.searchDrafts")}
                        value={retailDraftSearch}
                        onChange={(event) => setRetailDraftSearch(event.target.value)} />
                    {retailDraftSalesLoading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                            <CircularProgress size={24} />
                        </Box>
                    ) : retailDraftSalesError ? (
                        <Alert severity="error" action={
                            <Button color="inherit" onClick={fetchRetailDraftSales}>
                                {t("retailPos.retryDrafts")}
                            </Button>
                        }>
                            {t("retailPos.loadDraftsError")}
                        </Alert>
                    ) : filteredRetailDraftSales.length > 0 ? (
                        <List>
                            {filteredRetailDraftSales.map((draft) => {
                                const saleSummary = getRetailSaleSummary(draft);
                                return (
                                    <ListItemButton
                                        key={draft.name}
                                        onClick={() =>
                                            handleSelectRetailDraftSale(draft)
                                        }
                                        sx={{
                                            alignItems: "flex-start",
                                            borderBottom:
                                                "1px solid rgba(0, 0, 0, 0.08)",
                                        }}
                                    >
                                        <ListItemText
                                            primary={
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <span>
                                                        {getOrderShortName(
                                                            draft.name
                                                        )}
                                                    </span>
                                                    <span>
                                                        {saleSummary.totalAmount.toFixed(
                                                            2
                                                        )}
                                                    </span>
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        aria-label={t(
                                                            "retailPos.deleteSale"
                                                        )}
                                                        onClick={(event) =>
                                                            handleDeleteRetailDraftSale(
                                                                event,
                                                                draft
                                                            )
                                                        }
                                                        disabled={
                                                            deleteOrderMutation.isLoading
                                                        }
                                                    >
                                                        <DeleteOutline fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            }
                                            secondary={
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        display: "block",
                                                        color: "text.secondary",
                                                    }}
                                                >
                                                    <Box component="span" sx={{ display: "block" }}>
                                                        {[
                                                            draft.customer ||
                                                                t(
                                                                    "retailPos.saleLabel"
                                                                ),
                                                            draft.tracking_number,
                                                            draft.modified,
                                                        ]
                                                            .filter(Boolean)
                                                            .join(" - ")}
                                                    </Box>
                                                    <Box component="span" sx={{ display: "block" }}>
                                                        {t("retailPos.totalQty")}:{" "}
                                                        {saleSummary.totalQty}
                                                    </Box>
                                                    {saleSummary.itemSummary ? (
                                                        <Box
                                                            component="span"
                                                            sx={{
                                                                display: "block",
                                                                mt: 0.5,
                                                            }}
                                                        >
                                                            {saleSummary.itemSummary}
                                                        </Box>
                                                    ) : null}
                                                </Box>
                                            }
                                        />
                                    </ListItemButton>
                                );
                            })}
                        </List>
                    ) : (
                        <Box sx={{ py: 3, color: "text.secondary" }}>
                            {t("retailPos.noDraftSales")}
                        </Box>
                    )}
                </Box>
            </Dialog>

            <AddItemWidget
                kioskMode={isKioskMode}
                item={addedItem}
                open={addItemOpen || editOrderItemOpen}
                onClose={handleAddItemClose}
                onAddItem={handleAddItem}
                onUpdateItem={handleUpdateItem}
                editedOrderItem={editedOrderItem}
                pushItemWorker={pushItemToOrderMutation}
                readOnly={false}
            />
            {!isRetailPos && <SplitItemDialog
                open={!!splitItem}
                item={splitItem}
                onClose={() => setSplitItem(null)}
                onConfirm={handleSplitItemConfirm}
            />}
        </React.Fragment>
    );
};

export default PosPage;
